var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadGateway(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-server",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}@keyframes floating{0%,to{opacity:1;transform:translateY(0)}50%{transform:translateY(-10px)}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}svg#freepik_stories-server:not(.animated) .animable{opacity:0}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-67",
    className: "animable",
    style: {
      transformOrigin: "255.39px 344.36px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-67",
    d: "M101.24 426.64c85.14 45.44 223.17 45.44 308.3 0s85.13-119.12 0-164.56-223.17-45.44-308.3 0-85.13 119.12 0 164.56Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "255.39px 344.36px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-67",
    className: "animable",
    style: {
      transformOrigin: "347.465px 356.487px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-67",
    d: "m252.7 365.39 62.22 35.77a2.88 2.88 0 0 0 2.59 0l110.13-63.58a.79.79 0 0 0 0-1.5l-62.22-35.77a2.82 2.82 0 0 0-2.59 0L252.7 363.89a.79.79 0 0 0 0 1.5Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "340.17px 350.731px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.76 384c-.2-1.59-2.11-2.4-3.16-3l-42.48-24.6a6.11 6.11 0 0 0-6.08 0l-42.47 24.4c-1.25.73-3.3 2.11-3.3 3.72s1.12 2 3.18 3.17l42.17 24.36a6.94 6.94 0 0 0 6.94 0l43.52-24.93a3.25 3.25 0 0 0 1.68-3.12Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "394.021px 384.285px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Servers--inject-67",
    className: "animable animator-active",
    style: {
      transformOrigin: "218.51px 209.693px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft,1.5s Infinite linear floating",
      animationDelay: "0s,1s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Server--inject-67",
    className: "animable",
    style: {
      transformOrigin: "277.41px 175.693px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m297.73 257.89 10-5.78a4.79 4.79 0 0 1 4.33 0l62.83 36.27",
    style: {
      fill: "none",
      stroke: "#b0bec5",
      strokeMiterlimit: 10,
      transformOrigin: "336.31px 269.986px"
    },
    id: "el0obcpo89zs7n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.67 255.55 14.08-8.13a4.79 4.79 0 0 1 4.33 0L379 286",
    style: {
      fill: "none",
      stroke: "#b0bec5",
      strokeMiterlimit: 10,
      transformOrigin: "336.335px 266.451px"
    },
    id: "elj7gu190tue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383 283.69-70.95-41a4.79 4.79 0 0 0-4.33 0L289.6 253.2",
    style: {
      fill: "none",
      stroke: "#b0bec5",
      strokeMiterlimit: 10,
      transformOrigin: "336.3px 262.931px"
    },
    id: "el3h724a6yktp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.09 281.35-75-43.31a4.79 4.79 0 0 0-4.33 0l-22.22 12.82",
    style: {
      fill: "none",
      stroke: "#b0bec5",
      strokeMiterlimit: 10,
      transformOrigin: "336.315px 259.436px"
    },
    id: "elajbd0zdl1fm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.62 45.75-64.73 37.37a4.78 4.78 0 0 0-2.16 3.75v177.92a4.8 4.8 0 0 0 2.16 3.75l64.73 37.37a4.79 4.79 0 0 0 4.33 0l64.72-37.37a4.78 4.78 0 0 0 2.17-3.75V86.87a4.76 4.76 0 0 0-2.17-3.75L239 45.75a4.79 4.79 0 0 0-4.38 0Z",
    style: {
      fill: "#37474f",
      transformOrigin: "236.785px 175.824px"
    },
    id: "el7czjti0v3l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.84 86.86v177.93a4.8 4.8 0 0 1-2.16 3.75L239 305.91a4.34 4.34 0 0 1-2.16.52V123.5a4.48 4.48 0 0 0 2.16-.5l64.73-37.37.59-.49.77-.64a4.49 4.49 0 0 1 .75 2.36Z",
    style: {
      fill: "#263238",
      transformOrigin: "271.34px 195.466px"
    },
    id: "el3d339yw57sq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178 104.38 48.48 28a4.81 4.81 0 0 1 2.16 3.75v18.46c0 1.38-1 1.94-2.17 1.25l-48.47-28a4.78 4.78 0 0 1-2.17-3.75v-18.46c.02-1.38.99-1.94 2.17-1.25Z",
    style: {
      fill: "#455a64",
      transformOrigin: "202.235px 130.11px"
    },
    id: "el9bcenq0nzov",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.91 112.51a4.64 4.64 0 0 0 2.17 3.59l40.35 23.3c1.2.69 2.17.2 2.17-1.09a4.64 4.64 0 0 0-2.17-3.6l-40.35-23.3c-1.2-.69-2.17-.2-2.17 1.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "202.255px 125.405px"
    },
    id: "elddvpl5egi3j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.91 121.89a4.64 4.64 0 0 0 2.17 3.59l40.35 23.3c1.2.69 2.17.2 2.17-1.09a4.64 4.64 0 0 0-2.17-3.6l-40.35-23.3c-1.2-.69-2.17-.2-2.17 1.1Z",
    style: {
      fill: "#263238",
      transformOrigin: "202.255px 134.785px"
    },
    id: "elicunpkj1m3q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.08 120.79 22.21 12.83v4.69l-22.21-12.83a4.64 4.64 0 0 1-2.17-3.59c0-1.3.97-1.79 2.17-1.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "192.1px 129.394px"
    },
    id: "else5ebkjzjsb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178 137.21 48.48 28a4.8 4.8 0 0 1 2.16 3.75v18.44c0 1.38-1 1.94-2.17 1.25l-48.47-28a4.78 4.78 0 0 1-2.17-3.75v-18.44c.02-1.38.99-1.94 2.17-1.25Z",
    style: {
      fill: "#455a64",
      transformOrigin: "202.235px 162.93px"
    },
    id: "elq3y1j97cd4r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.91 145.34a4.64 4.64 0 0 0 2.17 3.6l40.35 23.29c1.2.69 2.17.2 2.17-1.09a4.64 4.64 0 0 0-2.17-3.6l-40.35-23.29c-1.2-.69-2.17-.2-2.17 1.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "202.255px 158.24px"
    },
    id: "elb2nfd9b3t67",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.91 154.72a4.64 4.64 0 0 0 2.17 3.6l40.35 23.29c1.2.7 2.17.2 2.17-1.09a4.64 4.64 0 0 0-2.17-3.6l-40.35-23.29c-1.2-.69-2.17-.2-2.17 1.09Z",
    style: {
      fill: "#263238",
      transformOrigin: "202.255px 167.622px"
    },
    id: "elccaf5mfeq3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.08 153.63 34.39 19.85v4.69l-34.39-19.85a4.64 4.64 0 0 1-2.17-3.6c0-1.29.97-1.78 2.17-1.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "198.19px 165.744px"
    },
    id: "elt5wvgdw2g5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178 170 48.48 28a4.8 4.8 0 0 1 2.16 3.75v18.45c0 1.38-1 1.94-2.17 1.25L178 193.5a4.78 4.78 0 0 1-2.17-3.75v-18.46c.02-1.38.99-1.94 2.17-1.29Z",
    style: {
      fill: "#455a64",
      transformOrigin: "202.235px 195.738px"
    },
    id: "els2fyguiphio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.91 178.17a4.64 4.64 0 0 0 2.17 3.6l40.35 23.3c1.2.69 2.17.2 2.17-1.1a4.64 4.64 0 0 0-2.17-3.59l-40.35-23.3c-1.2-.69-2.17-.2-2.17 1.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "202.255px 191.075px"
    },
    id: "elhn2v7enjqya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.91 187.56a4.64 4.64 0 0 0 2.17 3.59l40.35 23.3c1.2.69 2.17.2 2.17-1.1a4.64 4.64 0 0 0-2.17-3.59l-40.35-23.3c-1.2-.69-2.17-.2-2.17 1.1Z",
    style: {
      fill: "#263238",
      transformOrigin: "202.255px 200.455px"
    },
    id: "elquq2ow85bf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.08 186.46 14.08 8.13v4.69l-14.08-8.13a4.64 4.64 0 0 1-2.17-3.59c0-1.3.97-1.79 2.17-1.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "188.035px 192.714px"
    },
    id: "elep118axu90r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178 202.88 48.48 28a4.8 4.8 0 0 1 2.16 3.75v18.46c0 1.38-1 1.94-2.17 1.25l-48.47-28a4.78 4.78 0 0 1-2.17-3.75v-18.46c.02-1.38.99-1.94 2.17-1.25Z",
    style: {
      fill: "#455a64",
      transformOrigin: "202.235px 228.61px"
    },
    id: "elix2fsqy4su",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.91 211a4.64 4.64 0 0 0 2.17 3.59l40.35 23.3c1.2.69 2.17.2 2.17-1.1a4.64 4.64 0 0 0-2.17-3.59l-40.35-23.3c-1.2-.68-2.17-.19-2.17 1.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "202.255px 223.898px"
    },
    id: "elv2sttl9v8y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.91 220.39a4.64 4.64 0 0 0 2.17 3.59l40.35 23.3c1.2.69 2.17.2 2.17-1.09a4.64 4.64 0 0 0-2.17-3.6l-40.35-23.3c-1.2-.69-2.17-.2-2.17 1.1Z",
    style: {
      fill: "#263238",
      transformOrigin: "202.255px 233.285px"
    },
    id: "el4f0ui462up",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.08 219.29 22.21 12.82v4.69L182.08 224a4.64 4.64 0 0 1-2.17-3.59c0-1.32.97-1.81 2.17-1.12Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "192.1px 227.889px"
    },
    id: "el0wey4xfdk47r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178 235.71 48.48 28a4.8 4.8 0 0 1 2.16 3.75v18.44c0 1.38-1 1.94-2.17 1.25l-48.47-28a4.78 4.78 0 0 1-2.17-3.75V237c.02-1.42.99-2 2.17-1.29Z",
    style: {
      fill: "#455a64",
      transformOrigin: "202.235px 261.426px"
    },
    id: "elh8hlnwpjcf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.91 243.84a4.64 4.64 0 0 0 2.17 3.6l40.35 23.29c1.2.69 2.17.2 2.17-1.09a4.64 4.64 0 0 0-2.17-3.6l-40.35-23.29c-1.2-.7-2.17-.2-2.17 1.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "202.255px 256.738px"
    },
    id: "el0k1peiclqpln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.91 253.22a4.64 4.64 0 0 0 2.17 3.6l40.35 23.29c1.2.69 2.17.2 2.17-1.09a4.64 4.64 0 0 0-2.17-3.6l-40.35-23.29c-1.2-.69-2.17-.2-2.17 1.09Z",
    style: {
      fill: "#263238",
      transformOrigin: "202.255px 266.12px"
    },
    id: "el2mj429akio1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.08 252.13 30.33 17.51v4.69l-30.33-17.51a4.64 4.64 0 0 1-2.17-3.6c0-1.29.97-1.78 2.17-1.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "196.16px 263.074px"
    },
    id: "el09imiw97icd3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.94 134.8c2.24-1.3 4.06-.12 4.06 2.64v107.27a9.33 9.33 0 0 1-4.06 7.36c-2.24 1.3-4.06.11-4.06-2.65V142.15a9.31 9.31 0 0 1 4.06-7.35Z",
    style: {
      fill: "#37474f",
      transformOrigin: "246.94px 193.434px"
    },
    id: "elmylrlx9lcyg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.94 249.69a4.63 4.63 0 0 0 2-3.67V138.45c0-1.38-.91-2-2-1.33a4.65 4.65 0 0 0-2 3.68v107.57c-.03 1.38.88 1.97 2 1.32Z",
    style: {
      fill: "#263238",
      transformOrigin: "246.94px 193.402px"
    },
    id: "el8jztxgcehqa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.94 249.69a4.63 4.63 0 0 0 2-3.67v-51.43l-4.06 2.35v51.43c.03 1.38.94 1.97 2.06 1.32Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "246.91px 222.272px"
    },
    id: "elgmwttup71j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.12 127.76c2.25-1.3 4.07-.11 4.07 2.65v107.27a9.31 9.31 0 0 1-4.06 7.35c-2.25 1.3-4.07.12-4.07-2.64V135.12a9.33 9.33 0 0 1 4.06-7.36Z",
    style: {
      fill: "#37474f",
      transformOrigin: "259.125px 186.396px"
    },
    id: "elnbcv3kuyjwk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.13 242.66a4.65 4.65 0 0 0 2-3.67V131.42c0-1.39-.91-2-2-1.33a4.65 4.65 0 0 0-2 3.67v107.57c-.04 1.38.87 1.98 2 1.33Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "259.129px 186.37px"
    },
    id: "el6xsc3j6gdt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.31 120.73c2.24-1.3 4.06-.12 4.06 2.64v107.27a9.3 9.3 0 0 1-4.06 7.36c-2.24 1.3-4.06.11-4.06-2.65V128.08a9.31 9.31 0 0 1 4.06-7.35Z",
    style: {
      fill: "#37474f",
      transformOrigin: "271.31px 179.364px"
    },
    id: "elkb9qq0u0fhq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.31 235.62a4.63 4.63 0 0 0 2-3.67V124.38c0-1.38-.91-2-2-1.33a4.65 4.65 0 0 0-2 3.67V234.3c-.03 1.38.88 1.97 2 1.32Z",
    style: {
      fill: "#263238",
      transformOrigin: "271.31px 179.332px"
    },
    id: "elbnfuhxrf0m9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.31 235.62a4.63 4.63 0 0 0 2-3.67v-83.09l-4.06 2.34v83.1c.03 1.38.94 1.97 2.06 1.32Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "271.28px 192.372px"
    },
    id: "elgu0n6aus1nu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.5 113.69c2.24-1.3 4.06-.12 4.06 2.65v107.27a9.31 9.31 0 0 1-4.06 7.39c-2.25 1.3-4.06.12-4.06-2.64V121.05a9.29 9.29 0 0 1 4.06-7.36Z",
    style: {
      fill: "#37474f",
      transformOrigin: "283.5px 172.345px"
    },
    id: "elqc47ta1gkjj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.5 228.59a4.65 4.65 0 0 0 2-3.67V117.34c0-1.38-.91-2-2-1.32a4.63 4.63 0 0 0-2 3.67v107.57c-.03 1.38.88 1.98 2 1.33Z",
    style: {
      fill: "#263238",
      transformOrigin: "283.5px 172.298px"
    },
    id: "eltzxmsgnh9cg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.5 228.59a4.65 4.65 0 0 0 2-3.67v-18.16l-4.06 2.34v18.16c.03 1.38.94 1.98 2.06 1.33Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "283.47px 217.806px"
    },
    id: "el6klh393t8d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.68 106.66c2.25-1.3 4.07-.12 4.07 2.64v107.27a9.31 9.31 0 0 1-4.07 7.36c-2.24 1.3-4.06.11-4.06-2.65V114a9.31 9.31 0 0 1 4.06-7.34Z",
    style: {
      fill: "#37474f",
      transformOrigin: "295.685px 165.294px"
    },
    id: "eli2v534669y9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.68 221.55a4.63 4.63 0 0 0 2-3.67V110.31c0-1.38-.9-2-2-1.33a4.65 4.65 0 0 0-2 3.67v107.58c-.03 1.38.88 1.97 2 1.32Z",
    style: {
      fill: "#263238",
      transformOrigin: "295.68px 165.262px"
    },
    id: "elxj5fon9n45e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.68 221.55a4.63 4.63 0 0 0 2-3.67v-56.12l-4.06 2.34v56.13c.03 1.38.94 1.97 2.06 1.32Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "295.65px 191.787px"
    },
    id: "elrrt3s64vw5h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.61 265.12 298 234.29c1-.56 1.74-.11 1.74 1v19.45a3.83 3.83 0 0 1-1.74 3l-53.4 30.83c-1 .55-1.73.11-1.73-1v-19.45a3.82 3.82 0 0 1 1.74-3Z",
    style: {
      fill: "#37474f",
      transformOrigin: "271.305px 261.428px"
    },
    id: "eliodjkh5ng3p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.8 270.89c0 1.29 1 1.78 2.17 1.09l44.68-25.8a4.64 4.64 0 0 0 2.17-3.6c0-1.29-1-1.78-2.17-1.09L249 267.29a4.64 4.64 0 0 0-2.2 3.6Z",
    style: {
      fill: "#263238",
      transformOrigin: "271.31px 256.735px"
    },
    id: "el85f0sgcnw8e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.8 270.89c0 1.29 1 1.78 2.17 1.09l32.5-18.77v-4.69L249 267.29a4.64 4.64 0 0 0-2.2 3.6Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "264.135px 260.406px"
    },
    id: "eloavl8wj1t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.8 280.27c0 1.29 1 1.78 2.17 1.09l44.68-25.8a4.64 4.64 0 0 0 2.17-3.6c0-1.29-1-1.78-2.17-1.09L249 276.67a4.64 4.64 0 0 0-2.2 3.6Z",
    style: {
      fill: "#263238",
      transformOrigin: "271.31px 266.115px"
    },
    id: "elyz118rsxo6s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.8 280.27c0 1.29 1 1.78 2.17 1.09l12.19-7v-4.69l-12.19 7a4.64 4.64 0 0 0-2.17 3.6Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "253.98px 275.671px"
    },
    id: "el0a1pcpz148xj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.67 83.12 239 45.75a4.79 4.79 0 0 0-4.33 0l-64.78 37.37a1.32 1.32 0 0 0 0 2.5L234.62 123a4.79 4.79 0 0 0 4.33 0l64.72-37.36a1.32 1.32 0 0 0 0-2.52Z",
    style: {
      fill: "#455a64",
      transformOrigin: "236.795px 84.375px"
    },
    id: "el4uznk61af98",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.48 114.1-50.2-29a2.89 2.89 0 0 1-1.3-2.25v-1.7a2.89 2.89 0 0 1 1.3-2.25l50.2-29a2.84 2.84 0 0 1 2.6 0l50.21 29a2.86 2.86 0 0 1 1.3 2.25v1.69a2.89 2.89 0 0 1-1.3 2.25l-50.21 29a2.84 2.84 0 0 1-2.6.01Z",
    style: {
      fill: "#263238",
      transformOrigin: "236.785px 81.9975px"
    },
    id: "elzpixnw3klxa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.28 80.42 50.2 29a2.84 2.84 0 0 0 2.6 0l50.21-29c.72-.42.72-1.09 0-1.5l-50.21-28a2.84 2.84 0 0 0-2.6 0l-50.2 28c-.72.42-.72 1.08 0 1.5Z",
    style: {
      fill: "#455a64",
      transformOrigin: "236.785px 80.17px"
    },
    id: "elx3ppsx7y2ys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.79 109.72v4.69a2.63 2.63 0 0 1-1.3-.31l-50.21-29a2.86 2.86 0 0 1-1.3-2.25v-1.68a2.89 2.89 0 0 1 1.02-2.08c-.47.41-.39 1 .24 1.33l50.21 29a2.63 2.63 0 0 0 1.34.3Z",
    style: {
      fill: "#37474f",
      transformOrigin: "210.385px 96.7503px"
    },
    id: "eln4gmrtzi1qi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.48 100-34-19.61a2.88 2.88 0 0 1-1.3-2.25v-1.66a2.91 2.91 0 0 1 1.3-2.25l21.82-12.57a8.5 8.5 0 0 0 2.19-1.95l10.4-14a1.72 1.72 0 0 1 2.19-.45l34 19.6a2.87 2.87 0 0 1 1.3 2.25v11.07a2.89 2.89 0 0 1-1.3 2.25l-34 19.6a2.84 2.84 0 0 1-2.6-.03Z",
    style: {
      fill: "#263238",
      transformOrigin: "236.78px 72.6878px"
    },
    id: "elqdl98ftuh8n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.08 95.34 21.78-12.57a8.71 8.71 0 0 0 2.19-2l10.4-14a1.31 1.31 0 0 0-.41-2l-34-19.6a1.72 1.72 0 0 0-2.19.45l-10.4 14a8.08 8.08 0 0 1-2 2l-22 12.49a.79.79 0 0 0 0 1.5l34 19.61a2.84 2.84 0 0 0 2.63.12Z",
    style: {
      fill: "#455a64",
      transformOrigin: "236.829px 70.2808px"
    },
    id: "elvcs6q3hgvnh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272 64.85-34-19.6a1.72 1.72 0 0 0-2.19.45l-10.4 14a8.28 8.28 0 0 1-1.06 1.11S261 81.93 261 81.92a8.25 8.25 0 0 0 1.06-1.1l10.4-14a1.31 1.31 0 0 0-.46-1.97Z",
    style: {
      fill: "#37474f",
      transformOrigin: "248.54px 63.4777px"
    },
    id: "el4eenn64idhe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.76 74.58a3.35 3.35 0 0 1 3.05 0 .93.93 0 0 1 0 1.76 3.41 3.41 0 0 1-3.05 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "211.285px 75.4564px"
    },
    id: "elew0a11vyee6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.86 78.1a3.33 3.33 0 0 1 3 0 .93.93 0 0 1 0 1.76 3.39 3.39 0 0 1-3 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "217.36px 78.9765px"
    },
    id: "elm3wms6z51c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 81.61a3.41 3.41 0 0 1 3.05 0 .93.93 0 0 1 0 1.76 3.35 3.35 0 0 1-3.05 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#263238",
      transformOrigin: "223.525px 82.4936px"
    },
    id: "el1esn1qrs3zt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 85.13a3.41 3.41 0 0 1 3.05 0 .93.93 0 0 1 0 1.76 3.35 3.35 0 0 1-3.05 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#263238",
      transformOrigin: "229.525px 86.0136px"
    },
    id: "elb1pt4gxpqsc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.86,
    cy: 72.82,
    rx: 2.15,
    ry: 1.24,
    style: {
      fill: "#b0bec5",
      transformOrigin: "215.86px 72.82px"
    },
    id: "elc8endb6d4sj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.43 75.46a3.33 3.33 0 0 1 3 0 .93.93 0 0 1 0 1.76 3.39 3.39 0 0 1-3 0c-.85-.49-.85-1.28 0-1.76Z",
    style: {
      fill: "#263238",
      transformOrigin: "221.926px 76.3365px"
    },
    id: "elr7f27ob3kgh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.04,
    cy: 79.86,
    rx: 2.15,
    ry: 1.24,
    style: {
      fill: "#b0bec5",
      transformOrigin: "228.04px 79.86px"
    },
    id: "elvp0oyba6jj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.61 82.49a3.41 3.41 0 0 1 3 0 .93.93 0 0 1 0 1.76 3.35 3.35 0 0 1-3 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#263238",
      transformOrigin: "234.11px 83.3735px"
    },
    id: "elcb3cdhtqwq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.9 69.3a3.41 3.41 0 0 1 3 0 .93.93 0 0 1 0 1.76 3.35 3.35 0 0 1-3 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#263238",
      transformOrigin: "220.4px 70.1835px"
    },
    id: "el939cr9krkwf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 72.82a3.33 3.33 0 0 1 3 0 .93.93 0 0 1 0 1.76 3.39 3.39 0 0 1-3 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "226.5px 73.6965px"
    },
    id: "elyhhowear3np",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.09 76.34a3.35 3.35 0 0 1 3 0 .93.93 0 0 1 0 1.76 3.41 3.41 0 0 1-3 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#263238",
      transformOrigin: "232.59px 77.2165px"
    },
    id: "elogmd1qafex",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.17 88.58a3.35 3.35 0 0 1 3.05 0 .93.93 0 0 1 0 1.76 3.41 3.41 0 0 1-3.05 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "235.695px 89.4564px"
    },
    id: "eljltl32ckkfi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.26,
    cy: 86.82,
    rx: 2.15,
    ry: 1.24,
    style: {
      fill: "#263238",
      transformOrigin: "240.26px 86.82px"
    },
    id: "elvb20n6b22pc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.18 79.86a3.35 3.35 0 0 1 3 0 .93.93 0 0 1 0 1.76 3.41 3.41 0 0 1-3 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#263238",
      transformOrigin: "238.68px 80.7365px"
    },
    id: "eli3l4eqvgzj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.47 66.67a3.35 3.35 0 0 1 3.05 0 .93.93 0 0 1 0 1.76 3.41 3.41 0 0 1-3.05 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "224.995px 67.5464px"
    },
    id: "el06sl7egv7b9r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.09,
    cy: 71.06,
    rx: 2.15,
    ry: 1.24,
    style: {
      fill: "#263238",
      transformOrigin: "231.09px 71.06px"
    },
    id: "eln9h6zrf3q1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.66 73.7a3.39 3.39 0 0 1 3 0 .93.93 0 0 1 0 1.76 3.33 3.33 0 0 1-3 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "237.16px 74.5835px"
    },
    id: "el9jdm3uevrt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.27,
    cy: 78.1,
    rx: 2.15,
    ry: 1.24,
    style: {
      fill: "#263238",
      transformOrigin: "243.27px 78.1px"
    },
    id: "eleklvc1lpmf7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.31 83.31a3.35 3.35 0 0 1 3.05 0 .92.92 0 0 1 0 1.75 3.35 3.35 0 0 1-3.05 0 .92.92 0 0 1 0-1.75Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "244.835px 84.185px"
    },
    id: "elcr4hm4l12vr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.88 80.67a3.33 3.33 0 0 1 3 0c.85.48.85 1.27 0 1.76a3.39 3.39 0 0 1-3 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#263238",
      transformOrigin: "249.384px 81.5465px"
    },
    id: "els32ewg0fm3e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.86 95.65v4.68a2.69 2.69 0 0 1-1.37-.3l-34-19.61a2.86 2.86 0 0 1-1.3-2.25v-1.69a2.89 2.89 0 0 1 1.06-2.08c-.47.41-.39 1 .24 1.33l34 19.61a2.69 2.69 0 0 0 1.37.31Z",
    style: {
      fill: "#37474f",
      transformOrigin: "218.525px 87.3666px"
    },
    id: "elsh0urvyzhi8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 59.12a1.14 1.14 0 0 1 1.46-.3L261 75.84a.87.87 0 0 1 .26 1.3 1.15 1.15 0 0 1-1.46.31l-29.55-17.02a.88.88 0 0 1-.25-1.31Z",
    style: {
      fill: "#263238",
      transformOrigin: "245.628px 68.1321px"
    },
    id: "el1c6gtu9zx8y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 59.12a1.14 1.14 0 0 1 1.46-.3l22 12.68-1.22 1.65-22-12.68a.88.88 0 0 1-.24-1.35Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "241.622px 65.9125px"
    },
    id: "elxwzw077u12r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.43 55.84a1.14 1.14 0 0 1 1.46-.3l29.55 17.06a.87.87 0 0 1 .27 1.3 1.17 1.17 0 0 1-1.47.3L232.7 57.15a.88.88 0 0 1-.27-1.31Z",
    style: {
      fill: "#263238",
      transformOrigin: "248.07px 64.8676px"
    },
    id: "el82j6mqit0al",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.43 55.84a1.14 1.14 0 0 1 1.46-.3l7.34 4.24-1.23 1.6-7.34-4.23a.88.88 0 0 1-.23-1.31Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "236.731px 58.3875px"
    },
    id: "elk1vunkm3xs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.87 52.57a1.14 1.14 0 0 1 1.46-.3l29.55 17.06a.88.88 0 0 1 .27 1.31 1.16 1.16 0 0 1-1.46.3l-29.55-17.07a.87.87 0 0 1-.27-1.3Z",
    style: {
      fill: "#263238",
      transformOrigin: "250.51px 61.6021px"
    },
    id: "ellnp758jklqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.87 52.57a1.14 1.14 0 0 1 1.46-.3l15.39 8.86-1.22 1.64-15.39-8.85a.87.87 0 0 1-.24-1.35Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "243.184px 57.4475px"
    },
    id: "elopb02i2vij9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.31 49.29a1.15 1.15 0 0 1 1.46-.31L268.36 66a.88.88 0 0 1 .26 1.31 1.14 1.14 0 0 1-1.46.3l-29.58-17.02a.87.87 0 0 1-.27-1.3Z",
    style: {
      fill: "#263238",
      transformOrigin: "252.967px 58.2979px"
    },
    id: "el8jvc139nuxn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.31 49.29a1.15 1.15 0 0 1 1.46-.31l26.83 15.49-1.23 1.64-26.79-15.52a.87.87 0 0 1-.27-1.3Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "251.363px 57.4754px"
    },
    id: "elx82ctllkb3",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--server--inject-67",
    className: "animable",
    style: {
      transformOrigin: "161.615px 243.693px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m184 323.57 10-5.79a4.79 4.79 0 0 1 4.33 0l59.52 34.37a2.21 2.21 0 0 0 3.31-1.91V301",
    style: {
      fill: "none",
      stroke: "#b0bec5",
      strokeMiterlimit: 10,
      transformOrigin: "222.58px 326.722px"
    },
    id: "elzl7x14bx9i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.91 321.22 14.09-8.13a4.79 4.79 0 0 1 4.33 0l63.58 36.71a2.21 2.21 0 0 0 3.31-1.91V301",
    style: {
      fill: "none",
      stroke: "#b0bec5",
      strokeMiterlimit: 10,
      transformOrigin: "222.565px 325.547px"
    },
    id: "elzit397kq6bh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.85 318.87 194 308.4a4.79 4.79 0 0 1 4.33 0L266 347.46a2.2 2.2 0 0 0 3.3-1.91v-44.26",
    style: {
      fill: "none",
      stroke: "#b0bec5",
      strokeMiterlimit: 10,
      transformOrigin: "222.575px 324.522px"
    },
    id: "el0b53w0kz1ohj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.78 316.53 194 303.71a4.79 4.79 0 0 1 4.33 0l71.67 41.4a2.2 2.2 0 0 0 3.3-1.91v-41.91",
    style: {
      fill: "none",
      stroke: "#b0bec5",
      strokeMiterlimit: 10,
      transformOrigin: "222.54px 323.347px"
    },
    id: "el5giwu368mj3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.82 113.75-64.73 37.37a4.78 4.78 0 0 0-2.16 3.75v177.92a4.8 4.8 0 0 0 2.16 3.75l64.73 37.37a4.79 4.79 0 0 0 4.33 0l64.72-37.37a4.78 4.78 0 0 0 2.17-3.75V154.87a4.78 4.78 0 0 0-2.17-3.75l-64.72-37.37a4.79 4.79 0 0 0-4.33 0Z",
    style: {
      fill: "#37474f",
      transformOrigin: "118.985px 243.83px"
    },
    id: "elymxz22ovlb8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 154.86v177.93a4.8 4.8 0 0 1-2.16 3.75l-64.73 37.37a4.34 4.34 0 0 1-2.16.52V191.5a4.48 4.48 0 0 0 2.16-.52l64.73-37.37.59-.49.77-.64a4.49 4.49 0 0 1 .8 2.38Z",
    style: {
      fill: "#263238",
      transformOrigin: "153.475px 263.456px"
    },
    id: "ellitcts3278p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.22 172.38 48.48 28a4.78 4.78 0 0 1 2.16 3.75v18.45c0 1.38-1 1.94-2.17 1.25l-48.47-28a4.78 4.78 0 0 1-2.17-3.75v-18.45c0-1.38.95-1.94 2.17-1.25Z",
    style: {
      fill: "#455a64",
      transformOrigin: "84.455px 198.105px"
    },
    id: "elxaxl7tjz3r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.12 180.51a4.62 4.62 0 0 0 2.16 3.59l40.35 23.3c1.2.69 2.17.2 2.17-1.09a4.64 4.64 0 0 0-2.17-3.6l-40.35-23.3c-1.2-.69-2.16-.2-2.16 1.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "84.46px 193.405px"
    },
    id: "el32hv6v0r8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.12 189.89a4.62 4.62 0 0 0 2.16 3.59l40.35 23.3c1.2.69 2.17.2 2.17-1.09a4.64 4.64 0 0 0-2.17-3.6l-40.35-23.3c-1.2-.69-2.16-.2-2.16 1.1Z",
    style: {
      fill: "#263238",
      transformOrigin: "84.46px 202.785px"
    },
    id: "el007531jhr525a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.28 188.79 22.21 12.83v4.69l-22.21-12.83a4.62 4.62 0 0 1-2.16-3.59c0-1.3.96-1.79 2.16-1.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "74.305px 197.394px"
    },
    id: "elrt9q5bagxdp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.22 205.21 48.48 28a4.8 4.8 0 0 1 2.16 3.75v18.44c0 1.38-1 1.94-2.17 1.25l-48.47-28a4.78 4.78 0 0 1-2.17-3.75v-18.44c0-1.38.95-1.94 2.17-1.25Z",
    style: {
      fill: "#455a64",
      transformOrigin: "84.455px 230.93px"
    },
    id: "elphrpm9007z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.12 213.34a4.63 4.63 0 0 0 2.16 3.6l40.35 23.29c1.2.69 2.17.2 2.17-1.09a4.64 4.64 0 0 0-2.17-3.6l-40.35-23.29c-1.2-.69-2.16-.2-2.16 1.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "84.46px 226.24px"
    },
    id: "elfsj91l1sijc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.12 222.72a4.63 4.63 0 0 0 2.16 3.6l40.35 23.3c1.2.69 2.17.2 2.17-1.1a4.65 4.65 0 0 0-2.17-3.6l-40.35-23.29c-1.2-.69-2.16-.2-2.16 1.09Z",
    style: {
      fill: "#263238",
      transformOrigin: "84.46px 235.625px"
    },
    id: "elaf2frbjen0w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.28 221.63 34.39 19.85v4.69l-34.39-19.85a4.63 4.63 0 0 1-2.16-3.6c0-1.29.96-1.78 2.16-1.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "80.395px 233.744px"
    },
    id: "el52kkajzdgzh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.22 238 48.48 28a4.8 4.8 0 0 1 2.16 3.75v18.45c0 1.38-1 1.94-2.17 1.25l-48.47-28a4.78 4.78 0 0 1-2.17-3.75v-18.41c0-1.38.95-1.94 2.17-1.29Z",
    style: {
      fill: "#455a64",
      transformOrigin: "84.455px 263.738px"
    },
    id: "el7txtl7f7tus",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.12 246.17a4.63 4.63 0 0 0 2.16 3.6l40.35 23.3c1.2.69 2.17.2 2.17-1.1a4.64 4.64 0 0 0-2.17-3.59l-40.35-23.3c-1.2-.69-2.16-.2-2.16 1.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "84.46px 259.075px"
    },
    id: "elrdscx0t7sq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.12 255.56a4.62 4.62 0 0 0 2.16 3.59l40.35 23.3c1.2.69 2.17.2 2.17-1.1a4.64 4.64 0 0 0-2.17-3.59l-40.35-23.3c-1.2-.69-2.16-.2-2.16 1.1Z",
    style: {
      fill: "#263238",
      transformOrigin: "84.46px 268.455px"
    },
    id: "eltrzse7ckyw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.28 254.46 14.08 8.13v4.69l-14.08-8.13a4.62 4.62 0 0 1-2.16-3.59c0-1.3.96-1.79 2.16-1.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "70.24px 260.714px"
    },
    id: "el7cgizvgfc4k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.22 270.88 48.48 28a4.8 4.8 0 0 1 2.16 3.75v18.46c0 1.38-1 1.94-2.17 1.25l-48.47-28a4.78 4.78 0 0 1-2.17-3.75v-18.46c0-1.38.95-1.94 2.17-1.25Z",
    style: {
      fill: "#455a64",
      transformOrigin: "84.455px 296.61px"
    },
    id: "elo6akzqqsv5h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.12 279a4.62 4.62 0 0 0 2.16 3.59l40.35 23.3c1.2.69 2.17.2 2.17-1.09a4.64 4.64 0 0 0-2.17-3.6l-40.35-23.3c-1.2-.68-2.16-.19-2.16 1.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "84.46px 291.898px"
    },
    id: "elfdynxl3gti6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.12 288.39a4.62 4.62 0 0 0 2.16 3.61l40.35 23.3c1.2.69 2.17.2 2.17-1.09a4.64 4.64 0 0 0-2.17-3.6l-40.35-23.3c-1.2-.71-2.16-.22-2.16 1.08Z",
    style: {
      fill: "#263238",
      transformOrigin: "84.46px 301.298px"
    },
    id: "elus2i6i71hok",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.28 287.29 22.21 12.83v4.69L64.28 292a4.62 4.62 0 0 1-2.16-3.59c0-1.32.96-1.81 2.16-1.12Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "74.305px 295.894px"
    },
    id: "eldt4zpdgmg3w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.22 303.71 48.48 28a4.8 4.8 0 0 1 2.16 3.75v18.44c0 1.38-1 1.94-2.17 1.25l-48.47-28a4.78 4.78 0 0 1-2.17-3.75V305c0-1.42.95-2 2.17-1.29Z",
    style: {
      fill: "#455a64",
      transformOrigin: "84.455px 329.426px"
    },
    id: "elzo9xbe98kff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.12 311.84a4.63 4.63 0 0 0 2.16 3.6l40.35 23.29c1.2.69 2.17.2 2.17-1.09a4.64 4.64 0 0 0-2.17-3.6l-40.35-23.29c-1.2-.69-2.16-.2-2.16 1.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "84.46px 324.74px"
    },
    id: "elke7g80ghqdm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.12 321.22a4.63 4.63 0 0 0 2.16 3.6l40.35 23.29c1.2.69 2.17.2 2.17-1.09a4.64 4.64 0 0 0-2.17-3.6l-40.35-23.29c-1.2-.69-2.16-.2-2.16 1.09Z",
    style: {
      fill: "#263238",
      transformOrigin: "84.46px 334.12px"
    },
    id: "elom0h9hr133p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.28 320.13 30.33 17.51v4.69l-30.33-17.51a4.63 4.63 0 0 1-2.16-3.6c0-1.29.96-1.78 2.16-1.09Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "78.365px 331.074px"
    },
    id: "eld4f30xj6lm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.14 202.8c2.24-1.3 4.06-.12 4.06 2.64v107.27a9.31 9.31 0 0 1-4.06 7.36c-2.24 1.3-4.06.12-4.06-2.65V210.15a9.31 9.31 0 0 1 4.06-7.35Z",
    style: {
      fill: "#37474f",
      transformOrigin: "129.14px 261.435px"
    },
    id: "elgqv4xfu4vrs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.14 317.69a4.63 4.63 0 0 0 2-3.67V206.45c0-1.38-.91-2-2-1.33a4.66 4.66 0 0 0-2 3.68v107.57c-.03 1.38.86 1.97 2 1.32Z",
    style: {
      fill: "#263238",
      transformOrigin: "129.14px 261.402px"
    },
    id: "elgdegm9xs3g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.14 317.69a4.63 4.63 0 0 0 2-3.67v-51.43l-4.06 2.35v51.43c.03 1.38.92 1.97 2.06 1.32Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "129.11px 290.272px"
    },
    id: "elkscrlr3h3bi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.33 195.76c2.24-1.3 4.06-.11 4.06 2.65v107.27a9.31 9.31 0 0 1-4.06 7.35c-2.25 1.3-4.07.12-4.07-2.64V203.12a9.31 9.31 0 0 1 4.07-7.36Z",
    style: {
      fill: "#37474f",
      transformOrigin: "141.325px 254.396px"
    },
    id: "el52hz481xnga",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.33 310.66a4.65 4.65 0 0 0 2-3.67V199.42c0-1.39-.91-2-2-1.33a4.65 4.65 0 0 0-2 3.67v107.57c-.04 1.38.87 1.98 2 1.33Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "141.329px 254.37px"
    },
    id: "elrtikmstu1ls",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.51 188.73c2.24-1.3 4.06-.12 4.06 2.64v107.27a9.3 9.3 0 0 1-4.06 7.36c-2.24 1.3-4.06.11-4.06-2.65V196.08a9.31 9.31 0 0 1 4.06-7.35Z",
    style: {
      fill: "#37474f",
      transformOrigin: "153.51px 247.364px"
    },
    id: "el7efrfcrkjb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.51 303.62a4.63 4.63 0 0 0 2-3.67V192.38c0-1.38-.91-2-2-1.33a4.65 4.65 0 0 0-2 3.68V302.3c-.03 1.38.88 1.97 2 1.32Z",
    style: {
      fill: "#263238",
      transformOrigin: "153.51px 247.332px"
    },
    id: "elshq9duk00f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.51 303.62a4.63 4.63 0 0 0 2-3.67v-83.09l-4.06 2.34v83.1c.03 1.38.94 1.97 2.06 1.32Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "153.48px 260.372px"
    },
    id: "elnhgt422a53d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.7 181.69c2.24-1.3 4.06-.11 4.06 2.65v107.27a9.31 9.31 0 0 1-4.06 7.39c-2.25 1.3-4.06.12-4.06-2.64V189.05a9.29 9.29 0 0 1 4.06-7.36Z",
    style: {
      fill: "#37474f",
      transformOrigin: "165.7px 240.346px"
    },
    id: "el0zyd1eh53s1q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.7 296.59a4.65 4.65 0 0 0 2-3.67V185.34c0-1.38-.91-2-2-1.32a4.63 4.63 0 0 0-2 3.67v107.57c-.03 1.38.88 1.98 2 1.33Z",
    style: {
      fill: "#263238",
      transformOrigin: "165.7px 240.298px"
    },
    id: "elw2to3bqg6x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.7 296.59a4.65 4.65 0 0 0 2-3.67v-18.16l-4.06 2.35v18.15c.03 1.38.94 1.98 2.06 1.33Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "165.67px 285.806px"
    },
    id: "eleirv997m2w9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.88 174.66c2.25-1.3 4.07-.12 4.07 2.64v107.27a9.31 9.31 0 0 1-4.07 7.36c-2.24 1.3-4.06.11-4.06-2.65V182a9.31 9.31 0 0 1 4.06-7.34Z",
    style: {
      fill: "#37474f",
      transformOrigin: "177.885px 233.294px"
    },
    id: "el5ubokjq9fb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.88 289.55a4.61 4.61 0 0 0 2-3.67V178.31c0-1.38-.91-2-2-1.33a4.65 4.65 0 0 0-2 3.67v107.58c-.03 1.38.88 1.97 2 1.32Z",
    style: {
      fill: "#263238",
      transformOrigin: "177.88px 233.262px"
    },
    id: "elsyhvjrvkv8g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.88 289.55a4.61 4.61 0 0 0 2-3.67v-56.12l-4.06 2.34v56.13c.03 1.38.94 1.97 2.06 1.32Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "177.85px 259.787px"
    },
    id: "elu12d2a33vla",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m126.81 333.12 53.4-30.83c1-.56 1.74-.11 1.74 1v19.45a3.83 3.83 0 0 1-1.74 3l-53.4 30.83c-1 .56-1.73.11-1.73-1v-19.45a3.82 3.82 0 0 1 1.73-3Z",
    style: {
      fill: "#37474f",
      transformOrigin: "153.515px 329.43px"
    },
    id: "elaxtw51dbpi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 338.89c0 1.29 1 1.78 2.17 1.09l44.68-25.8a4.64 4.64 0 0 0 2.17-3.6c0-1.29-1-1.78-2.17-1.09l-44.68 25.8a4.64 4.64 0 0 0-2.17 3.6Z",
    style: {
      fill: "#263238",
      transformOrigin: "153.51px 324.735px"
    },
    id: "elnq8jatzmm0h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 338.89c0 1.29 1 1.78 2.17 1.09l32.5-18.77v-4.69l-32.5 18.77a4.64 4.64 0 0 0-2.17 3.6Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "146.335px 328.406px"
    },
    id: "elo81hcei6fx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 348.27c0 1.29 1 1.79 2.17 1.09l44.68-25.8A4.64 4.64 0 0 0 178 320c0-1.29-1-1.78-2.17-1.09l-44.68 25.8a4.64 4.64 0 0 0-2.15 3.56Z",
    style: {
      fill: "#263238",
      transformOrigin: "153.5px 334.137px"
    },
    id: "el41tgys4u63l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 348.27c0 1.29 1 1.79 2.17 1.09l12.19-7v-4.69l-12.19 7a4.64 4.64 0 0 0-2.17 3.6Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "136.18px 343.674px"
    },
    id: "eldl882xzaz6a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m185.87 151.12-64.72-37.37a4.79 4.79 0 0 0-4.33 0l-64.73 37.37a1.32 1.32 0 0 0 0 2.5L116.82 191a4.76 4.76 0 0 0 4.33 0l64.72-37.36a1.32 1.32 0 0 0 0-2.52Z",
    style: {
      fill: "#455a64",
      transformOrigin: "118.995px 152.377px"
    },
    id: "elqo7t4likcm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.68 182.1-50.2-29a2.89 2.89 0 0 1-1.3-2.25v-1.69a2.86 2.86 0 0 1 1.3-2.25l50.2-29a2.84 2.84 0 0 1 2.6 0l50.21 29a2.86 2.86 0 0 1 1.3 2.25v1.69a2.89 2.89 0 0 1-1.3 2.25l-50.21 29a2.84 2.84 0 0 1-2.6 0Z",
    style: {
      fill: "#263238",
      transformOrigin: "118.985px 150.005px"
    },
    id: "el852o695rdy3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.48 148.43 50.2 29a2.84 2.84 0 0 0 2.6 0l50.21-29c.72-.42.72-1.09 0-1.5l-50.21-28a2.84 2.84 0 0 0-2.6 0l-50.2 28c-.72.41-.72 1.07 0 1.5Z",
    style: {
      fill: "#455a64",
      transformOrigin: "118.985px 148.18px"
    },
    id: "elc65y1jvmexs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 177.72v4.69a2.63 2.63 0 0 1-1.3-.31l-50.21-29a2.86 2.86 0 0 1-1.3-2.25v-1.69a2.89 2.89 0 0 1 1.06-2.08c-.47.41-.39 1 .24 1.33l50.21 29a2.63 2.63 0 0 0 1.3.31Z",
    style: {
      fill: "#37474f",
      transformOrigin: "92.595px 164.745px"
    },
    id: "el4fvf6fvmpmh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.68 168-34-19.6a2.9 2.9 0 0 1-1.29-2.25v-1.7a2.9 2.9 0 0 1 1.29-2.25l21.78-12.57a8.5 8.5 0 0 0 2.19-2l10.4-14a1.72 1.72 0 0 1 2.19-.45l34 19.6a2.87 2.87 0 0 1 1.3 2.25v11.08a2.89 2.89 0 0 1-1.3 2.25l-34 19.6a2.84 2.84 0 0 1-2.56.04Z",
    style: {
      fill: "#263238",
      transformOrigin: "118.965px 140.625px"
    },
    id: "eltq91xr7crrr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.28 163.34 21.78-12.57a8.71 8.71 0 0 0 2.19-2l10.4-14a1.31 1.31 0 0 0-.41-2l-34-19.6a1.72 1.72 0 0 0-2.19.45l-10.4 14a8.08 8.08 0 0 1-2 2l-22 12.49a.79.79 0 0 0 0 1.5l34 19.61a2.84 2.84 0 0 0 2.63.12Z",
    style: {
      fill: "#455a64",
      transformOrigin: "119.029px 138.281px"
    },
    id: "elwgcafi8wi8j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.24 132.85-34-19.6a1.72 1.72 0 0 0-2.19.45l-10.4 14a8.28 8.28 0 0 1-1.06 1.11s36.55 21.11 36.56 21.1a8.25 8.25 0 0 0 1.06-1.1l10.4-14a1.31 1.31 0 0 0-.37-1.96Z",
    style: {
      fill: "#37474f",
      transformOrigin: "130.745px 131.473px"
    },
    id: "eledac75gfc9l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 142.58a3.35 3.35 0 0 1 3.05 0 .93.93 0 0 1 0 1.76 3.41 3.41 0 0 1-3.05 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "93.525px 143.456px"
    },
    id: "elimayemobew8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.06 146.1a3.33 3.33 0 0 1 3 0 .93.93 0 0 1 0 1.76 3.39 3.39 0 0 1-3 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "99.56px 146.976px"
    },
    id: "elp9np4xz7gt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.15 149.61a3.41 3.41 0 0 1 3 0 .93.93 0 0 1 0 1.76 3.35 3.35 0 0 1-3 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#263238",
      transformOrigin: "105.65px 150.493px"
    },
    id: "el50p2qtwaona",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.24 153.13a3.41 3.41 0 0 1 3.05 0 .93.93 0 0 1 0 1.76 3.35 3.35 0 0 1-3.05 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#263238",
      transformOrigin: "111.765px 154.014px"
    },
    id: "el9mad57rn40r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.53 139.94a3.35 3.35 0 0 1 3 0 .93.93 0 0 1 0 1.76 3.35 3.35 0 0 1-3 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "98.03px 140.82px"
    },
    id: "elxvdjwy4p90q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.15,
    cy: 144.34,
    rx: 2.15,
    ry: 1.24,
    style: {
      fill: "#263238",
      transformOrigin: "104.15px 144.34px"
    },
    id: "elyn3lz2jsoma",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.72 147a3.35 3.35 0 0 1 3 0 .92.92 0 0 1 0 1.75 3.35 3.35 0 0 1-3 0 .92.92 0 0 1 0-1.75Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "110.22px 147.875px"
    },
    id: "elft52tm0t1tk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.34,
    cy: 151.37,
    rx: 2.15,
    ry: 1.24,
    style: {
      fill: "#263238",
      transformOrigin: "116.34px 151.37px"
    },
    id: "eldji3djutwbr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.1 137.3a3.41 3.41 0 0 1 3.05 0 .93.93 0 0 1 0 1.76 3.35 3.35 0 0 1-3.05 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#263238",
      transformOrigin: "102.625px 138.184px"
    },
    id: "el5r1powg0gvi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.2 140.82a3.33 3.33 0 0 1 3 0 .93.93 0 0 1 0 1.76 3.39 3.39 0 0 1-3 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "108.7px 141.696px"
    },
    id: "el5ubib0rgspr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.29 144.34a3.35 3.35 0 0 1 3 0 .93.93 0 0 1 0 1.76 3.41 3.41 0 0 1-3 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#263238",
      transformOrigin: "114.79px 145.217px"
    },
    id: "el604tka4isbl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.37 156.58a3.35 3.35 0 0 1 3 0 .93.93 0 0 1 0 1.76 3.41 3.41 0 0 1-3 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "117.87px 157.457px"
    },
    id: "elfs1a04jdwwk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.94 153.94a3.41 3.41 0 0 1 3 0 .93.93 0 0 1 0 1.76 3.35 3.35 0 0 1-3 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#263238",
      transformOrigin: "122.44px 154.823px"
    },
    id: "elceg2dvcchmk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.38 147.86a3.35 3.35 0 0 1 3.05 0 .93.93 0 0 1 0 1.76 3.41 3.41 0 0 1-3.05 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#263238",
      transformOrigin: "120.905px 148.736px"
    },
    id: "elvu49gzrh46g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.2,
    cy: 135.55,
    rx: 2.15,
    ry: 1.24,
    style: {
      fill: "#b0bec5",
      transformOrigin: "107.2px 135.55px"
    },
    id: "elyeke3xs40l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.77 138.18a3.39 3.39 0 0 1 3 0 .93.93 0 0 1 0 1.76 3.33 3.33 0 0 1-3 0c-.85-.48-.85-1.27 0-1.76Z",
    style: {
      fill: "#263238",
      transformOrigin: "113.266px 139.064px"
    },
    id: "elho55yaz1i5l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.38,
    cy: 142.58,
    rx: 2.15,
    ry: 1.24,
    style: {
      fill: "#b0bec5",
      transformOrigin: "119.38px 142.58px"
    },
    id: "elt9foi8626ar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 145.22a3.35 3.35 0 0 1 3 0 .93.93 0 0 1 0 1.76 3.41 3.41 0 0 1-3 0 .93.93 0 0 1 0-1.76Z",
    style: {
      fill: "#263238",
      transformOrigin: "125.5px 146.097px"
    },
    id: "el1z0i4pveruh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.51 151.31a3.35 3.35 0 0 1 3 0 .92.92 0 0 1 0 1.75 3.35 3.35 0 0 1-3 0 .92.92 0 0 1 0-1.75Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "127.01px 152.185px"
    },
    id: "elt4q9rrwfoy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.6,
    cy: 149.55,
    rx: 2.15,
    ry: 1.24,
    style: {
      fill: "#263238",
      transformOrigin: "131.6px 149.55px"
    },
    id: "elj3qujwosdj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.06 163.65v4.68a2.69 2.69 0 0 1-1.37-.3l-34-19.61a2.86 2.86 0 0 1-1.3-2.25v-1.69a2.89 2.89 0 0 1 1.06-2.08c-.47.41-.39 1 .24 1.33l34 19.61a2.69 2.69 0 0 0 1.37.31Z",
    style: {
      fill: "#37474f",
      transformOrigin: "100.725px 155.367px"
    },
    id: "elvl1fz4343ue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.18 127.12a1.14 1.14 0 0 1 1.46-.3l29.56 17.06a.87.87 0 0 1 .26 1.3v.05a1.16 1.16 0 0 1-1.46.3l-29.55-17.06a.88.88 0 0 1-.27-1.35Z",
    style: {
      fill: "#263238",
      transformOrigin: "127.81px 136.172px"
    },
    id: "el4zxdnpcmfo7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.18 127.12a1.14 1.14 0 0 1 1.46-.3l22 12.68-1.22 1.65-22-12.68a.88.88 0 0 1-.24-1.35Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "123.802px 133.913px"
    },
    id: "ely6f6s353",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.63 123.84a1.14 1.14 0 0 1 1.46-.3l29.55 17.06a.87.87 0 0 1 .27 1.3 1.17 1.17 0 0 1-1.47.3l-29.54-17.05a.88.88 0 0 1-.27-1.31Z",
    style: {
      fill: "#263238",
      transformOrigin: "130.27px 132.868px"
    },
    id: "elz2snp44p5zb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.63 123.84a1.14 1.14 0 0 1 1.46-.3l7.34 4.24-1.22 1.64-7.34-4.23a.88.88 0 0 1-.24-1.35Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "118.922px 126.408px"
    },
    id: "elsljuh3xejpk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.07 120.57a1.14 1.14 0 0 1 1.46-.31l29.55 17.06a.88.88 0 0 1 .27 1.31 1.16 1.16 0 0 1-1.46.3l-29.55-17.06a.87.87 0 0 1-.27-1.3Z",
    style: {
      fill: "#263238",
      transformOrigin: "132.71px 129.594px"
    },
    id: "el17xb93ff0un",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.07 120.57a1.14 1.14 0 0 1 1.46-.31l15.47 8.82-1.22 1.64-15.39-8.85a.87.87 0 0 1-.32-1.3Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "125.45px 125.419px"
    },
    id: "el4obt0ywovud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.51 117.29a1.15 1.15 0 0 1 1.46-.31L150.56 134a.87.87 0 0 1 .26 1.3 1.14 1.14 0 0 1-1.46.3l-29.55-17.06a.87.87 0 0 1-.3-1.25Z",
    style: {
      fill: "#263238",
      transformOrigin: "135.184px 126.293px"
    },
    id: "elvck98u5gvs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.51 117.29a1.15 1.15 0 0 1 1.46-.31l26.83 15.49-1.23 1.64-26.82-15.48a.87.87 0 0 1-.24-1.34Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "133.547px 125.475px"
    },
    id: "eln1djzto6jk",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-67",
    className: "animable",
    style: {
      transformOrigin: "338.215px 299.47px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-67",
    className: "animable",
    style: {
      transformOrigin: "338.215px 299.47px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "338.215px 317.791px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.52 308.8v54.77a1.42 1.42 0 0 0 .65 1.12l52.5 30.31a1.42 1.42 0 0 0 1.3 0l1.75-1a1.48 1.48 0 0 0 .65-1.13v-54.81a.76.76 0 0 0-.75-.75l-55.35-29.26a.76.76 0 0 0-.75.75Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "284.945px 351.604px"
    },
    id: "el01jgy7m6z4lj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.62 337.31h-1.55a.75.75 0 0 0-.75.75v56.53c0 .41.29.58.65.37l1.75-1a1.48 1.48 0 0 0 .65-1.13v-54.77a.76.76 0 0 0-.75-.75Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "311.845px 366.18px"
    },
    id: "elcmom7wugqy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.07 246.05v54.76a1.44 1.44 0 0 0 .65 1.13l54.57 31.48a1.48 1.48 0 0 0 1.3 0l1.74-1a1.44 1.44 0 0 0 .65-1.13v-54.77a.74.74 0 0 0-.75-.75l-57.41-30.47a.74.74 0 0 0-.75.75Z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "390.525px 289.435px"
    },
    id: "elnhiobfq8lve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.23 275.77h-1.54a.74.74 0 0 0-.75.75V333c0 .42.29.58.65.38l1.74-1a1.44 1.44 0 0 0 .65-1.13v-54.73a.74.74 0 0 0-.75-.75Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "418.46px 304.618px"
    },
    id: "elwhuerpjef6i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.4 307.08v-.51a2.88 2.88 0 0 1 1.3-2.25l110.13-63.58a2.82 2.82 0 0 1 2.59 0l58.34 33.67a2.91 2.91 0 0 1 1.3 2.25v.52a2.88 2.88 0 0 1-1.3 2.25L313.63 343a2.82 2.82 0 0 1-2.59 0l-58.34-33.67a2.88 2.88 0 0 1-1.3-2.25Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "338.23px 291.87px"
    },
    id: "elxw148odbn2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.34 339.81v3.52A2.74 2.74 0 0 1 311 343l-58.33-33.68a2.87 2.87 0 0 1-1.3-2.25v-.52a2.87 2.87 0 0 1 1.06-2.08c-.47.4-.39 1 .24 1.33L311 339.5a2.63 2.63 0 0 0 1.34.31Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "281.855px 323.9px"
    },
    id: "elaoirjcq1ofm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.7 305.82 58.3 33.67a2.82 2.82 0 0 0 2.59 0l110.13-63.58a.79.79 0 0 0 0-1.5l-58.34-33.67a2.82 2.82 0 0 0-2.59 0L252.7 304.32a.79.79 0 0 0 0 1.5Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "338.21px 290.115px"
    },
    id: "elcxbvd0dizcq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.72 282.3 33-19.07a2.29 2.29 0 0 1 2.13 0l10.44 6.09c.59.34.59.89 0 1.24l-33 19.07a2.35 2.35 0 0 1-2.13 0l-10.44-6.1a.65.65 0 0 1 0-1.23Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "369.506px 276.426px"
    },
    id: "el97tbhi8mtkg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.57 270.47-3.5-2a.53.53 0 0 1 0-1l27.41-15.82a.53.53 0 0 0 0-1l-.28-.17a2 2 0 0 0-1.74 0l-26.66 15.34c-.47.28-.92.3-.93.05a1.75 1.75 0 0 1 0-.46l1.51-7.82a1.49 1.49 0 0 0-.68-1.47l-.28-.16a.66.66 0 0 0-1.05.48l-1.74 9.08a2.85 2.85 0 0 0 0 1A1.45 1.45 0 0 1 344 268l-16.62 9.6c-.48.27-.48.72 0 1l.28.16a1.91 1.91 0 0 0 1.74 0l15.88-9.17a3.47 3.47 0 0 1 .94-.45h.07l5.4 3.12a1.89 1.89 0 0 0 1.73 0l11.3-6.5c.48-.28.64-.63.36-.79a1.84 1.84 0 0 0-1.42.14l-10.2 4.91c-.46.27-.88.46-.89.45Z",
    style: {
      fill: "#ebebeb",
      transformOrigin: "351.927px 264.625px"
    },
    id: "el00psgu61qskx",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-67",
    className: "animable",
    style: {
      transformOrigin: "359.608px 246.201px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-67",
    className: "animable",
    style: {
      transformOrigin: "369.62px 274.532px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m381.69 260.7 9.88 5.7a2 2 0 0 1 0 3.55l-31.9 18.41a2.37 2.37 0 0 1-2.14 0l-9.87-5.7a2 2 0 0 1 0-3.54l31.9-18.42a2.35 2.35 0 0 1 2.13 0Z",
    style: {
      fill: "#37474f",
      transformOrigin: "369.62px 274.53px"
    },
    id: "el48p6voqcspp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.6 288.62a2.23 2.23 0 0 1-1.07-.26l-9.87-5.7a2 2 0 0 1 0-3.54l1-.6h9.92Z",
    style: {
      fill: "#263238",
      transformOrigin: "352.596px 283.57px"
    },
    id: "eljyu7v35ugbl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.65 279.12 31.9-18.42a2.37 2.37 0 0 1 2.14 0l9.87 5.7a.65.65 0 0 1 0 1.23l-31.9 18.42a2.35 2.35 0 0 1-2.13 0l-9.88-5.7a.65.65 0 0 1 0-1.23Z",
    style: {
      fill: "#455a64",
      transformOrigin: "369.605px 273.375px"
    },
    id: "elokpwgtnu2y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.81 269.2 1-.58c.05 0 0-.07 0-.1l-1.16-.67a.22.22 0 0 0-.16 0l-1 .58v.09l1.16.67a.18.18 0 0 0 .16.01Zm-2-2.31-1 .58v.09l1.16.67a.18.18 0 0 0 .16 0l1-.58v-.09l-1.13-.66a.18.18 0 0 0-.17-.01Zm-3.25 1.88-1.7 1v.09l1.16.67a.15.15 0 0 0 .16 0l1.7-1v-.09l-1.16-.67a.15.15 0 0 0-.14 0Zm1.78-1-1 .58c-.05 0 0 .07 0 .09l1.16.67a.18.18 0 0 0 .16 0l1-.58v-.1l-1.16-.67a.18.18 0 0 0-.14-.02Zm-3.92 2.23-1 .58v.1l1.16.67a.18.18 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.18.18 0 0 0-.16-.01Zm-1.47.85-1 .58c-.05 0 0 .07 0 .09l1.16.67a.18.18 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.18.18 0 0 0-.11.01Zm4.57 2.73 1-.58c.05 0 0-.07 0-.09l-1.16-.67a.18.18 0 0 0-.16 0l-1 .58v.09l1.16.68a.22.22 0 0 0 .16 0Zm-1.47.85 1-.58v-.1l-1.16-.67a.22.22 0 0 0-.16 0l-1 .58v.09l1.16.67a.18.18 0 0 0 .16.02Zm-1.47.84 1-.58v-.09l-1.16-.67a.15.15 0 0 0-.16 0l-1 .58c-.05 0 0 .06 0 .09l1.16.67a.15.15 0 0 0 .16.01Zm-1.46.85 1-.58v-.09l-1.16-.67a.15.15 0 0 0-.16 0l-1 .57a.06.06 0 0 0 0 .1l1.17.67a.18.18 0 0 0 .15.01Zm7.22-6.09 1-.58v-.09l-1.16-.67a.15.15 0 0 0-.16 0l-1 .58v.09l1.16.67a.15.15 0 0 0 .16-.03Zm-1.35 2.7 2.24-1.29v-.1l-2.82-1.62a.18.18 0 0 0-.16 0l-1.16.67v.09l1.49.87c.05 0 .05.06 0 .09l-.93.53v.1l1.16.67a.18.18 0 0 0 .19 0Zm-7.51-1-1 .58v.09l1.17.67a.18.18 0 0 0 .16 0l1-.58v-.1l-1.16-.67a.18.18 0 0 0-.17-.01Zm-1.46.85-1 .58v.09l1.16.67a.15.15 0 0 0 .16 0l1-.58c.05 0 0-.06 0-.09l-1.16-.67a.15.15 0 0 0-.18-.02Zm-7.34 9.5a.15.15 0 0 0 .16 0l1-.58c.05 0 0-.06 0-.09l-1.16-.67a.15.15 0 0 0-.16 0l-1 .58v.09Zm-4.41-2.72-1 .58v.09l1.16.67a.15.15 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.15.15 0 0 0-.16-.02Zm2.36 2a.22.22 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.18.18 0 0 0-.16 0l-1 .58c-.05 0 0 .07 0 .1Zm4.64 1.25 1-.58v-.1l-1.16-.67a.22.22 0 0 0-.16 0l-1 .58v.09l1.16.67a.18.18 0 0 0 .16-.02Zm-1.63.84a.15.15 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.15.15 0 0 0-.16 0l-1 .58c-.05 0 0 .06 0 .09Zm-3.9-4.93-1 .58v.09l1.16.67a.18.18 0 0 0 .16 0l1-.58v-.1l-1.16-.67a.22.22 0 0 0-.16-.02Zm7.34-4.24-1 .58v.09l1.16.68a.22.22 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.18.18 0 0 0-.16-.04Zm-5.87 3.39-1 .58v.09l1.16.68a.22.22 0 0 0 .16 0l1-.58c.05 0 0-.07 0-.09l-1.16-.67a.18.18 0 0 0-.16-.04Zm7.34-4.24-1 .58v.1l1.16.67a.18.18 0 0 0 .16 0l1-.58c.05 0 0-.07 0-.09l-1.16-.67a.18.18 0 0 0-.16-.04Zm-2.94 1.7-1 .58c-.05 0 0 .07 0 .09l1.16.67a.18.18 0 0 0 .16 0l1-.58v-.1l-1.16-.67a.18.18 0 0 0-.16-.02Zm-1.47.85-1 .58v.09l1.17.67a.15.15 0 0 0 .16 0l1-.58v-.09l-1.17-.65a.15.15 0 0 0-.16 0Zm-1.46.84-1 .58v.1l1.16.67a.18.18 0 0 0 .16 0l1-.58c.05 0 0-.07 0-.09l-1.16-.67a.18.18 0 0 0-.16-.04Zm7.5 1 1-.58c.05 0 0-.07 0-.1l-1.16-.67a.22.22 0 0 0-.16 0l-1 .58v.09l1.16.67a.18.18 0 0 0 .16.02ZM378.07 265l-1 .58v.09l1.17.67a.15.15 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.15.15 0 0 0-.17 0Zm-1.77 1-1 .58v.1l1.16.67a.18.18 0 0 0 .16 0l1-.58c.05 0 0-.07 0-.09l-1.16-.67a.18.18 0 0 0-.16-.01Zm3.24-1.87-1 .58c-.05 0 0 .07 0 .09l1.16.67a.18.18 0 0 0 .16 0l1-.58v-.1l-1.16-.67a.22.22 0 0 0-.16.05Zm-7.6 7.84 1-.58v-.1l-1.16-.67a.22.22 0 0 0-.16 0l-1 .58v.09l1.16.67a.18.18 0 0 0 .16.04Zm9.23-8.68a.18.18 0 0 0-.16 0l-1 .58v.1l1.16.67a.22.22 0 0 0 .16 0l1-.58v-.09ZM366.65 277l1-.58v-.09l-1.16-.67a.2.2 0 0 0-.17 0l-1 .58v.1l1.16.67a.22.22 0 0 0 .17-.01Zm18-10.39 1-.58c.05 0 0-.07 0-.1l-1.16-.67a.18.18 0 0 0-.16 0l-1 .58v.09l1.16.67a.18.18 0 0 0 .16-.01Zm-3.13-.12 1-.58v-.09l-1.16-.67a.18.18 0 0 0-.16 0l-1 .58c-.05 0 0 .06 0 .09l1.16.67a.15.15 0 0 0 .16-.02Zm1.31-2.19a.22.22 0 0 0-.16 0l-1 .58v.09l1.16.67a.18.18 0 0 0 .16 0l1-.58v-.1Zm.31-.17 2.82 1.62a.18.18 0 0 0 .16 0l1-.58c.05 0 0-.07 0-.09l-2.82-1.63a.18.18 0 0 0-.16 0l-1 .58s-.05.05 0 .08Zm-3.41 1.87-1 .58c-.05 0 0 .06 0 .09l1.16.67a.15.15 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.15.15 0 0 0-.16 0Zm-11.05 6.37-1 .59v.09l1.17.67a.18.18 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.18.18 0 0 0-.17-.03Zm14.32-4.94a.15.15 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.15.15 0 0 0-.16 0l-1 .58v.09Zm-12.87 4.08-1 .58v.09l1.16.67a.15.15 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.15.15 0 0 0-.14 0Zm-11 9.7a.18.18 0 0 0 .16 0l1-.58a.06.06 0 0 0 0-.1l-1.16-.67a.25.25 0 0 0-.17 0l-1 .58v.09Zm-2.21-2.07-1 .58v.09l1.16.67a.18.18 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.15.15 0 0 0-.14 0Zm3.84 1.23 1-.58v-.09l-1.16-.67a.18.18 0 0 0-.16 0l-1 .58a.06.06 0 0 0 0 .1l1.17.67a.22.22 0 0 0 .17-.01Zm1.46-.85 1-.58v-.09l-1.16-.67a.15.15 0 0 0-.16 0l-1 .58c-.05 0 0 .06 0 .09l1.16.67a.18.18 0 0 0 .18 0Zm1.47-.85 1-.58V278l-1.16-.67a.15.15 0 0 0-.16 0l-1 .58v.09l1.16.67a.15.15 0 0 0 .18 0Zm-5.3-.38-1 .58v.09l1.16.67a.15.15 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.15.15 0 0 0-.14 0Zm1.47-.85-1 .58v.09l1.16.67a.18.18 0 0 0 .16 0l1-.58c.05 0 0-.07 0-.1l-1.16-.67a.22.22 0 0 0-.14.01Zm5.87-3.39-1 .58v.09l1.16.67a.18.18 0 0 0 .16 0l1-.58c.05 0 0-.07 0-.1l-1.16-.67a.22.22 0 0 0-.14.01Zm-1.47.85-1 .58v.09l1.16.67a.15.15 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.15.15 0 0 0-.14 0Zm2.94-1.7-1 .58v.1l1.16.67a.22.22 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.18.18 0 0 0-.14-.01Zm-5.88 3.39-1 .58a.06.06 0 0 0 0 .1l1.17.67a.22.22 0 0 0 .16 0l1-.58v-.09l-1.17-.67a.18.18 0 0 0-.14-.01Zm1.47-.84-1 .58c-.05 0 0 .06 0 .09l1.16.67a.18.18 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.15.15 0 0 0-.14 0Zm-1.07 6 1-.58c.05 0 0-.07 0-.09l-1.16-.67a.18.18 0 0 0-.16 0l-1 .58v.09l1.16.68a.22.22 0 0 0 .18-.03Zm-8.61-.87-1.17-.67a.18.18 0 0 0-.16 0l-1 .58a.06.06 0 0 0 0 .1l1.17.67a.18.18 0 0 0 .16 0l1-.58s.06-.09.02-.12Zm2.19.64-1.16-.67a.22.22 0 0 0-.16 0l-1.54.89a.06.06 0 0 0 0 .1l1.17.67a.22.22 0 0 0 .16 0l1.54-.89s.06-.09.01-.12Zm-4-1.94-1.16-.67a.18.18 0 0 0-.16 0l-1.23.71c-.05 0 0 .07 0 .09l1.16.68a.22.22 0 0 0 .16 0l1.24-.72s.08-.08.03-.11Zm1-.54a.22.22 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.18.18 0 0 0-.16 0l-1 .58v.09Zm5.08 3.22-1.16-.67a.15.15 0 0 0-.16 0l-1.93 1.11c-.05 0 0 .07 0 .09l1.16.67a.18.18 0 0 0 .16 0l1.94-1.12s.03-.07-.02-.1Zm1 1.36-1.16-.67a.18.18 0 0 0-.16 0l-1.23.72v.09l1.16.67a.15.15 0 0 0 .16 0l1.24-.71s-.01-.09-.06-.12Zm4.88-10.89a.18.18 0 0 0 .16 0l1-.58v-.1l-1.16-.67a.22.22 0 0 0-.16 0l-1 .58v.09Zm-2.94 1.7a.15.15 0 0 0 .16 0l1-.58c.05 0 0-.06 0-.09l-1.16-.67a.15.15 0 0 0-.16 0l-1 .58v.09Zm-6.51 3.76a.18.18 0 0 0 .16 0l1-.58c.05 0 0-.07 0-.09l-1.16-.67a.18.18 0 0 0-.16 0l-1 .58v.1Zm8-4.61a.15.15 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.17.17 0 0 0-.17 0l-1 .58v.09Zm-2.94 1.7a.22.22 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.18.18 0 0 0-.16 0l-1 .58v.1Zm.34 8.45a.18.18 0 0 0-.16 0l-1.54.9c-.05 0 0 .06 0 .09l1.16.67a.15.15 0 0 0 .16 0l1.55-.89v-.09Zm-2.45-7.24a.18.18 0 0 0 .16 0l1-.58v-.1l-1.16-.67a.18.18 0 0 0-.16 0l-1 .58v.09Zm-1.46.85a.15.15 0 0 0 .16 0l1-.58v-.09l-1.17-.67a.15.15 0 0 0-.16 0l-1 .58v.09Zm31.04-9.34a.18.18 0 0 0-.16 0l-2.47 1.43v.09l1.16.67a.18.18 0 0 0 .16 0l2.47-1.43c.05 0 .05-.07 0-.09Zm-3.25 1.87a.15.15 0 0 0-.16 0l-1 .58v.09l1.17.67a.15.15 0 0 0 .16 0l1-.58v-.09Zm-19.88 11 1-.58v-.09l-1.17-.67a.18.18 0 0 0-.16 0l-1 .58v.1l1.16.67a.18.18 0 0 0 .17 0Zm17-9.31a.22.22 0 0 0-.16 0l-1 .58v.09l1.16.67a.18.18 0 0 0 .16 0l1-.58c.05 0 0-.07 0-.1Zm7.65-4.41a.18.18 0 0 0-.16 0l-1 .58v.1l1.16.67a.18.18 0 0 0 .16 0l1-.58v-.09Zm2.63-.18-2.83-1.63a.18.18 0 0 0-.16 0l-1 .58v.09l2.82 1.63a.15.15 0 0 0 .16 0l1-.58s0-.06-.04-.06Zm-15.77 7.76a.18.18 0 0 0-.16 0l-1.24.71v.09l1.16.68a.22.22 0 0 0 .16 0l1.24-.72v-.09Zm3.71-2.14a.15.15 0 0 0-.16 0l-1.55.89v.09l1.16.67a.18.18 0 0 0 .16 0l1.55-.9v-.09Zm-7.11 4.1a.22.22 0 0 0-.16 0l-8.27 4.77v.1l1.16.67a.18.18 0 0 0 .16 0l8.27-4.77v-.1Zm-8.73 5a.22.22 0 0 0-.16 0l-1.24.72v.09l1.16.67a.18.18 0 0 0 .16 0l1.24-.71v-.09Zm10.43-6a.18.18 0 0 0-.16 0l-1.24.71v.1l1.16.67a.22.22 0 0 0 .16 0l1.24-.71v-.1Zm-12.13 7a.18.18 0 0 0-.16 0l-1.24.72v.09l1.16.67a.15.15 0 0 0 .16 0l1.24-.71v-.09Zm15.53-9a.15.15 0 0 0-.16 0l-1.24.71v.09l1.16.67a.18.18 0 0 0 .16 0l1.24-.72v-.09Zm5.25-3a.18.18 0 0 0-.16 0l-1 .58v.1l1.16.67a.22.22 0 0 0 .16 0l1-.58v-.09Zm3.22-2.34 1-.58v-.09l-1.16-.67a.18.18 0 0 0-.16 0l-1 .58v.1l1.16.67a.18.18 0 0 0 .11.03Zm-6.56 0 1-.58v-.09l-1.16-.67a.2.2 0 0 0-.17 0l-1 .58v.09l1.16.68a.22.22 0 0 0 .12-.01ZM375 274.1l2.94-1.69v-.1l-1.16-.67a.18.18 0 0 0-.16 0l-2.94 1.69v.1l1.16.67a.18.18 0 0 0 .16 0Zm8.26-4.87a.18.18 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.18.18 0 0 0-.16 0l-1 .58c-.05 0 0 .07 0 .09Zm-1.5-1 1-.58v-.09l-1.16-.67a.18.18 0 0 0-.16 0l-1 .58c-.05 0 0 .07 0 .1l1.16.67a.18.18 0 0 0 .11.04Zm-8.28 6.77 1-.58v-.09l-1.16-.67a.18.18 0 0 0-.16 0l-1 .58c-.05 0 0 .07 0 .09l1.16.67a.18.18 0 0 0 .16 0Zm6.49-3.84a.15.15 0 0 0 .16 0l1-.58c.05 0 0-.06 0-.09l-1.16-.67a.15.15 0 0 0-.16 0l-1 .58v.09Zm-13.83 8.08 1-.58v-.1l-1.16-.67a.22.22 0 0 0-.16 0l-1 .58c-.05 0 0 .07 0 .09l1.16.67a.18.18 0 0 0 .16-.04Zm1.47-.85 1-.58v-.09l-1.16-.67a.18.18 0 0 0-.16 0l-1 .58v.09l1.16.68a.22.22 0 0 0 .16-.06Zm-2.93 1.61 1-.58v-.09l-1.16-.67a.15.15 0 0 0-.16 0l-1 .58v.09l1.17.67a.15.15 0 0 0 .15 0Zm5.87-3.39 1-.58v-.09l-1.17-.67a.15.15 0 0 0-.16 0l-1 .58v.09l1.16.67a.15.15 0 0 0 .17.03Zm-1.47.85 1-.58c.05 0 0-.07 0-.09l-1.16-.67a.18.18 0 0 0-.16 0l-1 .58v.1l1.16.67a.18.18 0 0 0 .16.02Zm2.92-1.66 1-.58v-.1l-1.16-.67a.18.18 0 0 0-.16 0l-1 .58v.09l1.17.67a.18.18 0 0 0 .15.01Zm6.71-12.54a.18.18 0 0 0 .16 0l1-.58v-.09l-.31-.18a.15.15 0 0 0-.16 0l-1 .58c-.05 0 0 .06 0 .09Zm-7.22 4.66a.15.15 0 0 0 .16 0l1-.58c.05 0 0-.06 0-.09l-1.16-.67a.15.15 0 0 0-.16 0l-1 .58v.09Zm2.93-1.7a.18.18 0 0 0 .16 0l1-.58v-.09l-1.16-.68a.22.22 0 0 0-.16 0l-1 .58v.09Zm-4.7 2.78a.18.18 0 0 0 .16 0l1-.58v-.09l-1.17-.68a.22.22 0 0 0-.16 0l-1 .58v.09Zm3.26-1.88a.18.18 0 0 0 .16 0l1-.58a.06.06 0 0 0 0-.1l-1.17-.67a.18.18 0 0 0-.16 0l-1 .58v.09Zm-6.2 3.58a.15.15 0 0 0 .16 0l1-.58c.05 0 0-.06 0-.09l-1.16-.67a.15.15 0 0 0-.16 0l-1 .58v.09Zm1.47-.85a.18.18 0 0 0 .16 0l1-.58v-.1l-1.16-.67a.18.18 0 0 0-.16 0l-1 .58v.09Zm7.55-4.85a.18.18 0 0 0 .16 0l1-.58v-.1l-.3-.18a.22.22 0 0 0-.16 0l-1 .58v.09Zm4.4-2.54a.15.15 0 0 0 .16 0l1-.58c.05 0 0-.06 0-.09l-.31-.18a.18.18 0 0 0-.16 0l-1 .58v.09Zm2.44 1.41a.15.15 0 0 0 .16 0l1-.58c.05 0 0-.06 0-.09l-1.16-.67a.15.15 0 0 0-.16 0l-1 .58v.09Zm3.67 3.72 1-.58c.05 0 0-.06 0-.09l-1.16-.67a.15.15 0 0 0-.16 0l-1 .58v.09l1.16.67a.15.15 0 0 0 .16-.05Zm-9.05-3.44a.18.18 0 0 0 .16 0l1-.58v-.09l-.31-.18a.18.18 0 0 0-.16 0l-1 .58a.06.06 0 0 0 0 .1Zm-11.95 7.4a.18.18 0 0 0 .16 0l1-.58v-.09l-1.16-.67a.18.18 0 0 0-.16 0l-1 .58v.1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "369.609px 273.502px"
    },
    id: "elleiyg2y8mql",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Computer--inject-67",
    className: "animable",
    style: {
      transformOrigin: "351.594px 237.711px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m364.6 262.4-12 6.93h-.06l-4.54-2.65a2.46 2.46 0 0 1-1.11-2.42l1.7-8.8 10-8.09 2 1.16-1.69 8.8a2.45 2.45 0 0 0 1.1 2.42Z",
    style: {
      fill: "#455a64",
      transformOrigin: "355.733px 258.35px"
    },
    id: "el1qm2khnwq0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.6 269.33v2.31l-6.27-3.64a3.69 3.69 0 0 1-1.67-3.65l1.93-10.06 2 1.15-1.7 8.8a2.46 2.46 0 0 0 1.11 2.42l4.53 2.62Z",
    style: {
      fill: "#263238",
      transformOrigin: "348.61px 262.965px"
    },
    id: "elei3trmx1u5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474f",
      transformOrigin: "358.6px 267.02px"
    },
    id: "elnr18s4b1ooe",
    className: "animable",
    d: "m364.6 262.4-12 6.93v2.31l12-6.93v-2.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.62 204a2.3 2.3 0 0 1 1 1.81v36.84a2.36 2.36 0 0 1-1.07 1.85L329.64 271a2 2 0 0 1-3.07-1.78v-36.8a2.36 2.36 0 0 1 1.07-1.85l45.91-26.51a2.29 2.29 0 0 1 2.07-.06Z",
    style: {
      fill: "#455a64",
      transformOrigin: "351.594px 237.547px"
    },
    id: "elb47tb4sst18",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.64 271a2 2 0 0 1-3.07-1.78v-36.8a2.19 2.19 0 0 1 .31-1L362.61 252Z",
    style: {
      fill: "#263238",
      transformOrigin: "344.589px 251.366px"
    },
    id: "elysg7crvd9a8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.62 242.67v-36.84c0-.68-.48-1-1.07-.61l-45.91 26.51a2.35 2.35 0 0 0-1.07 1.84v36.84c0 .68.48 1 1.07.62l45.91-26.51a2.36 2.36 0 0 0 1.07-1.85Z",
    style: {
      fill: "#37474f",
      transformOrigin: "352.595px 238.122px"
    },
    id: "elo32ynjbcdwr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374 207.27-43.58 25.16a1.86 1.86 0 0 0-.86 1.47v32.71c0 .54.38.77.86.49L374 242a1.88 1.88 0 0 0 .85-1.48v-32.7c.01-.6-.37-.82-.85-.55Z",
    style: {
      fill: "#fff",
      transformOrigin: "352.205px 237.188px"
    },
    id: "eldxemywmtm6w",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-67",
    className: "animable",
    style: {
      transformOrigin: "310.3px 303.888px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m313.08 326.59-25.85-14.92a2.88 2.88 0 0 1-1.3-2.25v-15.76a2.86 2.86 0 0 1 1.3-2.25l17.71-10.22a2.84 2.84 0 0 1 2.6 0l25.83 14.91a2.86 2.86 0 0 1 1.3 2.25v15.76a2.86 2.86 0 0 1-1.3 2.25l-17.7 10.22a2.87 2.87 0 0 1-2.59.01Z",
    style: {
      fill: "#263238",
      transformOrigin: "310.3px 303.884px"
    },
    id: "eluzx5dzzkd5m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.67 307.82 17.7-10.22a.79.79 0 0 0 0-1.5l-25.83-14.91a2.84 2.84 0 0 0-2.6 0l-17.71 10.22a.79.79 0 0 0 0 1.5l25.84 14.92a2.87 2.87 0 0 0 2.6-.01Z",
    style: {
      fill: "#455a64",
      transformOrigin: "310.3px 294.506px"
    },
    id: "elhcoi9loykik",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.38 308.14v18.76a2.74 2.74 0 0 1-1.3-.31l-25.84-14.91a2.87 2.87 0 0 1-1.3-2.25v-15.77a2.91 2.91 0 0 1 1-2c-.36.41-.26.91.32 1.25l25.85 14.92a2.71 2.71 0 0 0 1.27.31Z",
    style: {
      fill: "#37474f",
      transformOrigin: "300.16px 309.28px"
    },
    id: "elb33gcoyb67a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.7 292.36a1.88 1.88 0 0 1 1.71 0L314 303.09c.47.28.49.73 0 1a1.85 1.85 0 0 1-1.7 0l-18.58-10.72c-.47-.29-.48-.73-.02-1.01Z",
    style: {
      fill: "#37474f",
      transformOrigin: "303.861px 298.226px"
    },
    id: "elmtdpr5l1c7d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.7 292.36a1.88 1.88 0 0 1 1.71 0l11.31 6.53-1.68 1-11.31-6.53c-.48-.28-.49-.72-.03-1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "300.041px 296.022px"
    },
    id: "elj88ljkgqnfk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.92 290.5a1.88 1.88 0 0 1 1.71 0l18.58 10.72c.48.28.49.73 0 1a1.85 1.85 0 0 1-1.7 0L297 291.5c-.53-.28-.54-.72-.08-1Z",
    style: {
      fill: "#37474f",
      transformOrigin: "307.081px 296.361px"
    },
    id: "el2w09vnnlaxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.92 290.5a1.88 1.88 0 0 1 1.71 0l1.52.87-1.69 1-1.46-.87c-.53-.28-.54-.72-.08-1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "298.369px 291.332px"
    },
    id: "elyromi7ejvvb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.15 288.64a1.85 1.85 0 0 1 1.7 0l18.58 10.72c.48.28.49.73 0 1a1.88 1.88 0 0 1-1.71 0l-18.58-10.72c-.45-.28-.46-.72.01-1Z",
    style: {
      fill: "#37474f",
      transformOrigin: "310.297px 294.499px"
    },
    id: "el785cfgqaxig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.15 288.64a1.85 1.85 0 0 1 1.7 0l6.57 3.79-1.68 1-6.57-3.79c-.48-.28-.49-.72-.02-1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "304.112px 290.932px"
    },
    id: "el2ubrqj7iadm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.37 286.78a1.85 1.85 0 0 1 1.7 0l18.58 10.72c.48.28.49.72 0 1a1.88 1.88 0 0 1-1.71 0l-18.58-10.72c-.44-.28-.46-.72.01-1Z",
    style: {
      fill: "#37474f",
      transformOrigin: "313.519px 292.639px"
    },
    id: "elhjo4svh1dr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.37 286.78a1.85 1.85 0 0 1 1.7 0l13.31 7.68-1.68 1-13.31-7.68c-.47-.28-.49-.72-.02-1Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "310.704px 291.017px"
    },
    id: "eltkvlphm2fql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.59 284.92a1.88 1.88 0 0 1 1.71 0l18.58 10.72c.47.28.48.72 0 1a1.88 1.88 0 0 1-1.71 0l-18.57-10.72c-.46-.28-.47-.73-.01-1Z",
    style: {
      fill: "#37474f",
      transformOrigin: "316.743px 290.78px"
    },
    id: "elhdvzg1eut1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.59 284.92a1.88 1.88 0 0 1 1.71 0l16.7 9.66-1.68 1-16.73-9.65c-.45-.29-.46-.74 0-1.01Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "315.624px 290.147px"
    },
    id: "elarcusg0t41v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.4 321.46v-3.2a2.59 2.59 0 0 1 1-2.08c.56-.33 1 .08 1 .91v3.19a2.6 2.6 0 0 1-1 2.09c-.54.32-1-.09-1-.91Z",
    style: {
      fill: "#37474f",
      transformOrigin: "317.4px 319.272px"
    },
    id: "elqj2rddqkzl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.47 316.66a1.45 1.45 0 0 0-.68 1.16c0 .43.3.6.68.39a1.49 1.49 0 0 0 .67-1.17c0-.42-.3-.6-.67-.38Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "317.465px 317.433px"
    },
    id: "elgas37sc254h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.61 319.62v-3.2a2.58 2.58 0 0 1 1-2.08c.56-.33 1 .08 1 .91v3.19a2.61 2.61 0 0 1-1 2.09c-.55.32-1-.09-1-.91Z",
    style: {
      fill: "#37474f",
      transformOrigin: "320.61px 317.432px"
    },
    id: "elwq4o4xfsec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.62 318.5a1.47 1.47 0 0 0-.67 1.16c0 .43.3.6.67.39a1.51 1.51 0 0 0 .68-1.17c0-.43-.3-.6-.68-.38Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "320.625px 319.272px"
    },
    id: "elj2ourznzop8",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-67",
    className: "animable",
    style: {
      transformOrigin: "387.882px 326.474px",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Legs--inject-67",
    className: "animable",
    style: {
      transformOrigin: "358.942px 349.171px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.47 359.07c.38.51.45 1.67.84 3.25a7.37 7.37 0 0 1 .26 3.57 7.13 7.13 0 0 1-4 3.15c-2.07.64-4.63.1-7.11-1.38s-4.34-3.27-7.86-4.28-5.29-1.82-7-3.16c-2-1.56-3.22-3.91.52-4.92s10.53.56 17.92.88Z",
    style: {
      fill: "#263238",
      transformOrigin: "366.69px 362.135px"
    },
    id: "el4spq4e5nkhk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.47 354.45V360s-.76 1.84-3.92 2a4.77 4.77 0 0 1-4.19-2v-5.49Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "375.415px 358.23px"
    },
    id: "elpk1hgnywws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.89 318.2c0 6.89 1.94 38.68 1.94 38.68s2.82 3.56 8.94 0l2.08-35.27Z",
    style: {
      fill: "#37474f",
      transformOrigin: "375.37px 338.331px"
    },
    id: "elms0d9w1f9h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.84 369.9c.39.51.45 1.68.84 3.25a4.64 4.64 0 0 1-3.77 6.72c-2.08.65-4.64.11-7.11-1.37s-4.35-3.28-7.87-4.28-5.29-1.82-7-3.16c-2-1.57-3.21-3.92.52-4.92s10.53.55 17.92.87Z",
    style: {
      fill: "#263238",
      transformOrigin: "350.107px 372.975px"
    },
    id: "elcy1tp20qid5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.84 365.28v5.54s-.76 1.84-3.91 2a4.78 4.78 0 0 1-4.2-2v-5.49Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "358.785px 369.055px"
    },
    id: "elfxh5dk39zi9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.26 329c0 6.9 1.94 38.68 1.94 38.68s2.82 3.57 8.94 0l2.08-35.27Z",
    style: {
      fill: "#37474f",
      transformOrigin: "358.74px 349.133px"
    },
    id: "ells92pga7qmc",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-67",
    className: "animable",
    style: {
      transformOrigin: "397.195px 360.782px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.69 394.44a4.56 4.56 0 0 0 .08.78 1.84 1.84 0 0 0 .7 1.08 2 2 0 0 0 2.14-.16 6.53 6.53 0 0 0 3-5.12 2.1 2.1 0 0 0-.84-1.87l-.14-.08a1.82 1.82 0 0 0-1.25-.05 3.53 3.53 0 0 0-.73.32 6.5 6.5 0 0 0-2.96 5.1Z",
    style: {
      fill: "#455a64",
      transformOrigin: "376.654px 392.735px"
    },
    id: "els9tjlrdhaxr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.5 388.1a2.63 2.63 0 0 1 1.31-.4 1.54 1.54 0 0 1 .83.23h.08l1.9 1.1a1.82 1.82 0 0 0-1.25-.05 3.53 3.53 0 0 0-.73.32 6.5 6.5 0 0 0-2.95 5.1 4.56 4.56 0 0 0 .08.78 1.84 1.84 0 0 0 .7 1.08l-2-1.13-.17-.1h-.05a2.19 2.19 0 0 1-.72-1.82 6.5 6.5 0 0 1 2.97-5.11Z",
    style: {
      fill: "#263238",
      transformOrigin: "375.071px 391.98px"
    },
    id: "elacqf20s55rm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.63 377.27a3.64 3.64 0 0 0 .08.77 1.81 1.81 0 0 0 .7 1.08 2 2 0 0 0 2.14-.17 6.52 6.52 0 0 0 3-5.11 2.08 2.08 0 0 0-.84-1.87l-.14-.08a1.77 1.77 0 0 0-1.25 0 3 3 0 0 0-.73.31 6.52 6.52 0 0 0-2.96 5.07Z",
    style: {
      fill: "#455a64",
      transformOrigin: "408.595px 375.564px"
    },
    id: "elbmjykrshji8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.44 370.92a2.73 2.73 0 0 1 1.31-.4 1.55 1.55 0 0 1 .83.24h.08l1.9 1.1a1.77 1.77 0 0 0-1.25 0 3 3 0 0 0-.73.31 6.52 6.52 0 0 0-2.95 5.11 3.64 3.64 0 0 0 .08.77 1.81 1.81 0 0 0 .7 1.08l-2-1.13-.16-.1h-.05a2.16 2.16 0 0 1-.73-1.81 6.53 6.53 0 0 1 2.97-5.17Z",
    style: {
      fill: "#263238",
      transformOrigin: "407.011px 374.825px"
    },
    id: "elb904gowwf4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.93 401.15a3.64 3.64 0 0 1-.08.77 1.76 1.76 0 0 1-.7 1.08 2 2 0 0 1-2.15-.17 6.5 6.5 0 0 1-3-5.11 2.07 2.07 0 0 1 .83-1.87l.14-.08a1.79 1.79 0 0 1 1.26 0 3.13 3.13 0 0 1 .72.31 6.52 6.52 0 0 1 2.98 5.07Z",
    style: {
      fill: "#455a64",
      transformOrigin: "396.96px 399.446px"
    },
    id: "eleeg7ifrnopl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.13 394.8a2.8 2.8 0 0 0-1.32-.4 1.55 1.55 0 0 0-.83.24h-.07l-1.91 1.1a1.79 1.79 0 0 1 1.26 0 3.13 3.13 0 0 1 .72.31 6.52 6.52 0 0 1 2.95 5.11 3.64 3.64 0 0 1-.08.77 1.76 1.76 0 0 1-.7 1.08l2-1.13.17-.1h.05a2.19 2.19 0 0 0 .72-1.81 6.52 6.52 0 0 0-2.96-5.17Z",
    style: {
      fill: "#263238",
      transformOrigin: "398.549px 398.705px"
    },
    id: "eludyhgejv3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.67 391a3.71 3.71 0 0 1-.09.78 1.75 1.75 0 0 1-.7 1.08 2.08 2.08 0 0 1-2.15-.17 6.52 6.52 0 0 1-2.95-5.12 2.12 2.12 0 0 1 .83-1.87l.15-.08a1.85 1.85 0 0 1 1.26-.05 3.71 3.71 0 0 1 .72.32 6.51 6.51 0 0 1 2.93 5.11Z",
    style: {
      fill: "#455a64",
      transformOrigin: "417.721px 389.282px"
    },
    id: "elbbyfb31afo8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.86 384.65a2.69 2.69 0 0 0-1.32-.4 1.57 1.57 0 0 0-.83.23h-.07l-1.91 1.1a1.85 1.85 0 0 1 1.26-.05 3.71 3.71 0 0 1 .72.32 6.51 6.51 0 0 1 3 5.1 3.71 3.71 0 0 1-.09.78 1.75 1.75 0 0 1-.7 1.08l2-1.13.17-.1a2.17 2.17 0 0 0 .72-1.81 6.52 6.52 0 0 0-2.95-5.12Z",
    style: {
      fill: "#263238",
      transformOrigin: "419.274px 388.53px"
    },
    id: "ela7ywf6brhaf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.59 378.54a3.64 3.64 0 0 1-.08.77 1.81 1.81 0 0 1-.7 1.08 2 2 0 0 1-2.14-.17 6.5 6.5 0 0 1-2.95-5.11 2.07 2.07 0 0 1 .83-1.87l.14-.08a1.77 1.77 0 0 1 1.25-.05 3 3 0 0 1 .73.31 6.52 6.52 0 0 1 2.92 5.12Z",
    style: {
      fill: "#455a64",
      transformOrigin: "377.65px 376.821px"
    },
    id: "elgsiex2istvi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.78 372.19a2.73 2.73 0 0 0-1.31-.4 1.55 1.55 0 0 0-.83.24h-.08l-1.9 1.1a1.77 1.77 0 0 1 1.25-.05 3 3 0 0 1 .73.31 6.52 6.52 0 0 1 2.95 5.11 3.64 3.64 0 0 1-.08.77 1.81 1.81 0 0 1-.7 1.08l1.95-1.13.16-.1a.1.1 0 0 0 .05 0 2.16 2.16 0 0 0 .73-1.81 6.53 6.53 0 0 0-2.92-5.12Z",
    style: {
      fill: "#263238",
      transformOrigin: "379.184px 376.07px"
    },
    id: "eltke18g9em3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "403.48px 373.445px"
    },
    id: "eli7js9hr5h2",
    className: "animable",
    d: "m398.21 372.3 10.54-3.02v2.25l-10.54 6.08v-5.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "402.965px 370.535px"
    },
    id: "el2y1jgmgdaer",
    className: "animable",
    d: "m398.21 372.3-1.03-.64 10.57-2.89 1 .51-10.54 3.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "386.18px 375.08px"
    },
    id: "el9lzdp32ek7j",
    className: "animable",
    d: "m393.65 379.02-14.94-5.6v-2.28l14.94 1.33v6.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "386.625px 371.66px"
    },
    id: "eleh2sbdlf8f",
    className: "animable",
    d: "m378.71 371.14 1.1-.29 14.73.95-.89.67-14.94-1.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.25 378.3c0 1.69 5.2 1.69 5.2 0v-14.78h-5.2Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "395.85px 371.544px"
    },
    id: "elw4cltpgvf1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.15 374.45 400 393h-2l-2.67-18.56a3.22 3.22 0 0 0 1.82.01Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "397.665px 383.72px"
    },
    id: "eljnbfb9qblj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "396.715px 385.3px"
    },
    id: "el46ms2n29dif",
    className: "animable",
    d: "M395.38 374.45v5.1l2.67 16.6v-3.14l-2.67-18.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "399.025px 394.58px"
    },
    id: "elscx86qdbmy",
    className: "animable",
    d: "M398.05 393.01H400v3.14h-1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "384.855px 381.985px"
    },
    id: "ela13tjy57jx9",
    className: "animable",
    d: "m394.49 379.4-19.27 10.1v-3.11l19.27-11.92v4.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.49 374.47a2.27 2.27 0 0 1-1.24-.56L374 385.57l1.2.82Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "384.245px 380.15px"
    },
    id: "el8qtaid8oek7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "374.62px 387.535px"
    },
    id: "elqd89o24p66",
    className: "animable",
    d: "M375.22 389.5v-3.11l-1.2-.82v3.02l1.2.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "408.495px 380.095px"
    },
    id: "eljuwk03gb0co",
    className: "animable",
    d: "m418.79 385.93-20.59-7.05v-4.62l20.59 8.56v3.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.2 374.26c.17-.05.24-.35.25-.8l20.95 9.11-.61.25Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "408.8px 378.14px"
    },
    id: "el2x2mtcotxmt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "419.09px 384.25px"
    },
    id: "eln8vjqeezhwo",
    className: "animable",
    d: "M419.39 382.57v3.01l-.6.35v-3.11l.6-.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.25 337.77h-8.8v30.48c0 2.53 8.8 2.53 8.8 0Z",
    style: {
      fill: "#f0f0f0",
      transformOrigin: "395.85px 353.959px"
    },
    id: "elf4hbgxihyo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 340.51a4.39 4.39 0 0 1 2.2-3.81l30.8-17.78a4.38 4.38 0 0 1 4.4 0l30.79 17.78a4.4 4.4 0 0 1 2.2 3.81l-35.19 20.32Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "397.195px 339.579px"
    },
    id: "elzlbdeue1kxd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 340.51v2.54l33 19.06a4.36 4.36 0 0 0 2.17.58 4.32 4.32 0 0 0 2.18-.58l33-19.06v-2.54l-33 19.06a4.33 4.33 0 0 1-2.18.59 4.37 4.37 0 0 1-2.17-.59Z",
    style: {
      fill: "#fafafa",
      transformOrigin: "397.175px 351.6px"
    },
    id: "elf2bgbim4byi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 340.51v2.54l33 19.06a4.36 4.36 0 0 0 2.17.58v-2.53a4.37 4.37 0 0 1-2.17-.59Z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "379.585px 351.6px"
    },
    id: "el2mx92109otl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 340.51a4.36 4.36 0 0 1 .47-2l33.27 19.2a2.87 2.87 0 0 0 2.89 0l33.28-19.2a4.39 4.39 0 0 1 .47 2l-35.19 20.32L362 340.51Z",
    style: {
      opacity: 0.1,
      transformOrigin: "397.19px 349.67px"
    },
    className: "animable",
    id: "eldrw7a5fe916"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-67",
    className: "animable",
    style: {
      transformOrigin: "381.199px 299.385px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.69 326.65s-28.57-8.63-33.53-10-14.5-3.65-17.28-2.41-4.2 2.7-4.45 6.71c-.05.76 0 4.43 0 4.43s13.81 4.28 25.12 4.28 30.14-3.01 30.14-3.01Z",
    style: {
      fill: "#263238",
      transformOrigin: "394.049px 321.771px"
    },
    id: "eldcaa2zgd629",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa8a7",
      transformOrigin: "403.47px 282.48px"
    },
    id: "el3g8l17ujths",
    className: "animable",
    d: "m397.27 278.1 1.9 10.24 10.5 1.21-1.51-14.14-10.89 2.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.47 269.92s-1.38 4.22-1 4.48a7.46 7.46 0 0 0 2.3.14Z",
    style: {
      fill: "#f28f8f",
      transformOrigin: "387.587px 272.247px"
    },
    id: "elv8txben6ydr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.18 256.38c-1.81 1.9-3.53 5.09-2.77 13.16.83 8.84 3.47 11.2 4.58 11.72 1.67.77 7.33-.58 9.17-1.94 2.31-1.7 6.64-5.93 7.78-11.14 1.33-6.13-.38-13.09-4.86-14.5-6.3-1.98-12.37 1.09-13.9 2.7Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "398.302px 267.26px"
    },
    id: "el1rige9hm6i6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05 260.73c1.07 2 3.1 7.06 8.85 8.49 0 0 .31-3.43 3.16-3.47s3.82 3.47 2.4 5.92-3.19 1.89-3.19 1.89.29 4.82 3.77 6.54a9 9 0 0 0 8-.53c1.71-1.09 3.7-5.84 4.72-9.65 2.17-8.07 1.78-14.24-3.35-15.49-1.08-3.39-2.81-4.47-6-4.69-6.94-.45-11.43 4.69-17.2 4.69-3.05 0-2.39 3.98-1.16 6.3Z",
    style: {
      fill: "#263238",
      transformOrigin: "400.013px 265.253px"
    },
    id: "elluuuffi656",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.29 255 3.47-1.49a1.89 1.89 0 1 0-3.47 1.49Z",
    style: {
      fill: "#263238",
      transformOrigin: "411.931px 253.644px"
    },
    id: "elwakkgatu93n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.62 323.21c0 5.49.51 11.2-1.77 15.22s-12.66 12.3-24.33 10.33c-7.63-1.28-32.27-10.67-32.27-10.67s-10.91-4-11-6.91c0-.7-.07-1.43 0-2.19.23-3.82 1.78-7.93 9.76-7.72 8.72.23 34.59 4.47 34.59 4.47Z",
    style: {
      fill: "#37474f",
      transformOrigin: "386.944px 335.16px"
    },
    id: "elpm1a4eu4euq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.59 287.74c-.94-2.87-4.58-6-8.22-5.31-6.68 1.24-14 3.41-15.94 4s.87 14.73-6.69 19.19l-1 18.76a16.09 16.09 0 0 0 4.76 5.57c3.12 2 7.46 5 15.31 4.31a19.35 19.35 0 0 0 13.87-7.59s-.09-17.73-.39-25.66c-.24-6.76-1.05-11.3-1.7-13.27Z",
    style: {
      fill: "#455a64",
      transformOrigin: "404.71px 308.347px"
    },
    id: "eldvvw4w409rn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.55 309.23a25 25 0 0 0 5.34-8.85s0 7-5.42 10.71Z",
    style: {
      fill: "#37474f",
      transformOrigin: "391.18px 305.735px"
    },
    id: "elblclraakn84",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.43 286.41c-4.12 1.24-6.64 1.46-11.19 8.47s-14.55 20.93-15.54 22.6c-1.37 2.33-2 5.09-.78 7.23s4.34 1.12 8.86-2.85 13-14.69 13-14.69a74.79 74.79 0 0 0 5.65-20.76Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "381.35px 306.108px"
    },
    id: "elajrw0vcm8it",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.43 286.41a31.4 31.4 0 0 0-6 1.89A9.47 9.47 0 0 0 385 292c-3.19 5.3-7.75 12.84-7.75 12.84s-.78 6.57 7.2 8.86l4.24-4.58a23.64 23.64 0 0 0 4.23-6.29c1.76-3.95 3.81-10.22 2.51-16.42Z",
    style: {
      fill: "#455a64",
      transformOrigin: "386.535px 300.055px"
    },
    id: "elr6g3lcibf8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.31 325.69c-3.82-.46-12.37-12.18-15.22-15.91s-5.24-5.94-7.81-7.35a10.27 10.27 0 0 1-5.5-8.12c-.65-4.18 3.24-6.85 6.43-2.65 2 2.67 4.06 4.36 4.17 3.91s-.63-2.3-.61-4.24c0-2.32 1.65-.79 2.14 0a29.75 29.75 0 0 1 1.72 3.85c.81 2.08.48 4.19 1.47 5.62s14.29 14.2 14.29 14.2Z",
    style: {
      fill: "#ffa8a7",
      transformOrigin: "355.549px 307.617px"
    },
    id: "elnmyk3khx8s",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "418.44px 318.405px"
    },
    id: "el908qscexnfi",
    className: "animable",
    d: "M434.05 289.69v39.34l-31.22 18.09v-39.31l31.22-18.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      transformOrigin: "418.44px 318.405px"
    },
    className: "animable",
    d: "M434.05 289.69v39.34l-31.22 18.09v-39.31l31.22-18.12z",
    id: "eliuwto522y0a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 345.48 2.84 1.64v-36.05c0-1.71.51-2.56 1.2-2.94 2.38-1.46 5.52 1.65 5.52 1.65v-2.62l30.17-17.46c-2.84-1.64-4.7-2.72-10.43.53s-22.53 13-25.19 14.61c-2.13 1.31-4.12 2.84-4.12 6.41Z",
    style: {
      fill: "#b0bec5",
      transformOrigin: "419.86px 317.623px"
    },
    id: "el7rrq4wy8dxv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.11 304.84c2.62-1.7 19.46-11.36 25.19-14.61s7.59-2.17 10.43-.53l-30.17 17.46a7.54 7.54 0 0 0-5.45-2.32Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      transformOrigin: "421.92px 297.643px"
    },
    className: "animable",
    id: "elwhbeai29y27"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b0bec5",
      transformOrigin: "424.64px 299.735px"
    },
    id: "elovzj5yoo0b9",
    className: "animable",
    d: "m409.55 309.78 30.18-17.53v-2.56l-30.17 17.47-.01 2.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      transformOrigin: "424.64px 299.735px"
    },
    className: "animable",
    d: "m409.55 309.78 30.18-17.53v-2.56l-30.17 17.47-.01 2.62z",
    id: "elc4k24m78vvu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 359.63a2.65 2.65 0 0 0 1.36-.37 2.68 2.68 0 0 0 1.37-2.36v-20.63a1.4 1.4 0 0 0-2.8 0v20.52l-2.22-1.28a1.39 1.39 0 0 0-1.91.51 1.41 1.41 0 0 0 .51 1.91l2.32 1.33a2.71 2.71 0 0 0 1.37.37Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "409.173px 347.254px"
    },
    id: "el8re96xedx5i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.08 349.69a2.75 2.75 0 0 0 1.36-.37 2.71 2.71 0 0 0 1.37-2.37v-20.63a1.4 1.4 0 0 0-2.8 0v20.52l-2.22-1.28a1.39 1.39 0 0 0-1.91.51 1.41 1.41 0 0 0 .51 1.91l2.32 1.34a2.82 2.82 0 0 0 1.37.37Z",
    style: {
      fill: "#e6e6e6",
      transformOrigin: "426.253px 337.305px"
    },
    id: "el8k2w721lair",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadGateway);
export default __webpack_public_path__ + "static/media/badGateway.0e1746136389c84f89783da9cc3aa106.svg";
export { ForwardRef as ReactComponent };